<template>
          <div class="w3-card-4">
                <header class="w3-container w3-theme-d2">
                    <h3>My Remedials</h3>
                </header>
                <div style="padding:10px">
                    <large-button class="w3-theme-dark" @click="$router.push('myremedials')">Remedials</large-button>                    
                </div>

                <!-- <div style="padding:10px">
                    <large-button class="w3-theme-dark" @click="process">Add Remedials</large-button>                    
                </div> -->

                <footer class="w3-small"  style="padding:10px"><b>Go to the Remedials page to make create/manage your remedials.</b></footer>
          </div>
    
</template>



<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "Home",
    methods:{

      process(){
          let sample = [
  {
    "JobNumber": "",
    "Received": "10/03/2016",
    "Address": "37 Andrew Jack Rd Millwater",
    "Issue": "Knock down all  pins on stairs & transitions",
    "Installer": "Ross",
    "CustomerName": "Zhang &Song",
    "CustomerPhone": 210655356,
    "GBContact": "Mike Clark Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Mike Clark Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/09/2016",
    "Address": "28 Pioneer",
    "Issue": "Issues Johnny sorted",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Zhang",
    "CustomerPhone": 2101592,
    "GBContact": "Nic Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Nic Smith",
    "Status": "Fixed by Johnny",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "GB035",
    "Received": "3/06/2016",
    "Address": "12 Skipjack Pass, Silverdale",
    "Issue": "Carpet at ranch slider needs tucking",
    "Installer": "Kelvin",
    "CustomerName": "Zane",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "TBF 10/06/2016",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/06/2017",
    "Address": "72 Paremoremo Rd Paremoremo",
    "Issue": "carpet lifting in hall & hwc due to flooding",
    "Installer": "Ross",
    "CustomerName": "Yun",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "3/03/2018",
    "Address": "31 Liquidambar Dr Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Yoon",
    "CustomerPhone": 211718457,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/07/2016",
    "Address": "28 Gumdigger Rise Millwater",
    "Issue": "Carpet is pulling away from smooth edge",
    "Installer": "Ross",
    "CustomerName": "Yolanda",
    "CustomerPhone": 2102488681,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "yolandavt@gmail.com",
    "GBStart": "Ross Murray",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/04/2018",
    "Address": "16 Vue Terrace Silverdale",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Yaping",
    "CustomerPhone": "0210 323254",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "26/04/2017",
    "Address": "5 Saltmarsh Rd Hobsonville",
    "Issue": "lift carpet for floor remedial& return to refit",
    "Installer": "Dave Walker",
    "CustomerName": "Yan",
    "CustomerPhone": "021 909 605 Brad Small",
    "GBContact": "Brad Small Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brad Small Uni",
    "Status": "Fixed by Dave",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/07/2016",
    "Address": "5 Aporo Dr Huapai",
    "Issue": "Join in Lounge",
    "Installer": "Ross",
    "CustomerName": "Worthington",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Completed",
    "Notes": "Explained join good, wait a few months to see if settles",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/01/2017",
    "Address": "12 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Wilamina Poto",
    "CustomerPhone": "021 768 423",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "6/04/2017",
    "Address": "12 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Wilamina Poto",
    "CustomerPhone": "021 768 423",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/03/2018",
    "Address": "97 Hobsonville Pt Rd",
    "Issue": "refit smoothedge at main bathroom",
    "Installer": "Ross",
    "CustomerName": "Wen-Song",
    "CustomerPhone": "021 027 383 69",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/08/2017",
    "Address": "14 Hooton Dr Huapai",
    "Issue": "reinstate carpet where repair undertaken",
    "Installer": "",
    "CustomerName": "Wendy Crenfeldt",
    "CustomerPhone": "021 848 844",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/02/2016",
    "Address": "34 Marae Rd Greenhithe",
    "Issue": "re-stretch bedroom",
    "Installer": "Grant(Jared)",
    "CustomerName": "Wendy",
    "CustomerPhone": "027 204 3792",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/12/2017",
    "Address": "33 Headland Dr Long Bay",
    "Issue": "lift carpet for Stonewood to repair floor, relay Jan 2018",
    "Installer": "Ross",
    "CustomerName": "Wellingham",
    "CustomerPhone": "027  270 5003",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/03/2016",
    "Address": "43 Harris Dr Millwater",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Wayne Harris",
    "CustomerPhone": "021 366 346",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/01/2017",
    "Address": "70 Westmuir Crescent Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Warwick Steele",
    "CustomerPhone": 220455037,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "woky1955@yahoo.com",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/04/2017",
    "Address": "59 Harris Dr Millwater",
    "Issue": "inspect joins and attend",
    "Installer": "Norm",
    "CustomerName": "Warren Seet",
    "CustomerPhone": 223539979,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/07/2017",
    "Address": "28 Peters Lane Taupaki",
    "Issue": "vinyl plank lifting",
    "Installer": "Dave",
    "CustomerName": "Vicki Hamilton",
    "CustomerPhone": "027 283 0413",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Dave",
    "Notes": "Dave  completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "22/03/2018",
    "Address": "56 Onekiritea Rd Hobsonville",
    "Issue": "carpet lifting at tiles + different coloured tufts cut out",
    "Installer": "Ross",
    "CustomerName": "Vicki",
    "CustomerPhone": 272442860,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/12/2017",
    "Address": "21 Dida Park Ave Huapai",
    "Issue": "knock down all pins and refit carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Vianca Lagerwall",
    "CustomerPhone": "021 0607 168",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 13,
    "Received": "17/04/2018",
    "Address": "LOT 7, 74 SQUADRON DRIVE HOB",
    "Issue": "Rodney",
    "Installer": "COMPLETED BY WAYNE, CREDIT IN SYSTEM FOR NZC UNDERLAY",
    "CustomerName": "UNIVERSAL HOMES?????????",
    "CustomerPhone": "GABE AK FLOORING",
    "GBContact": "021-578 250",
    "GB": "",
    "CustomerEmail": "TRACEY",
    "GBStart": "021-578 250",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 50,
    "Received": "3/05/2018",
    "Address": "LOT 1, 34 TONAR STREET, NORTHCOTE",
    "Issue": "Central",
    "Installer": "SEAL CUT IN VINYL DONE",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "RHYS BAKER 021-588 591",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "SITE MANAGNER",
    "GBStart": "RHYS BAKER 021-588 591",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 60,
    "Received": "11/04/2018",
    "Address": "37 MAPOU RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CHECK ALL CARPET AT STAIRS-TREADS-SOME LOOSE ROSS TO FIX 15/05/2018",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "021 2099234",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "Rachel",
    "GBStart": "021 2099234",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 51,
    "Received": "7/05/2018",
    "Address": "LOT 26, 27 MAPOU RD, HOB",
    "Issue": "Rodney",
    "Installer": "NO SMOOTHEDGE STAIRS-GRANT BOOKED THURS 12/07/2018 COMPLETED GRANT MIN CHARGE",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "BADDI",
    "GBContact": 294736590,
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "CLAIRE",
    "GBStart": 294736590,
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 44,
    "Received": "26/04/2018",
    "Address": "LOT 4, 38 TONAR ST, NORTHCOTE",
    "Issue": "Central",
    "Installer": "REPAIR VINYL JOIN  DONE KANE",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "REECE BAKER 021-588 591",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 38,
    "Received": "20/04/2018",
    "Address": "LOT 2, 4 PAETAHI LANE, NORTHCOTE",
    "Issue": "Central",
    "Installer": "REPAIR JOIN IN THE VINYL - BOOK ROSS 11/5/18 ORGANISE KANE",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "RHYS BAKER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 39,
    "Received": "20/04/2018",
    "Address": "LOT 5, 135 HOBSONVILLE PT RD",
    "Issue": "Rodney",
    "Installer": "CARPET COMING LOOSE AT STAIRS WAYNE BOOKED WED 16/05/2018 CODE = 7072",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "021-268 5514",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "JUAN",
    "GBStart": "021-268 5514",
    "Status": "",
    "Notes": "IAN DONACHIE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 53,
    "Received": "3/05/2018",
    "Address": "15 HARVARD ST HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "WAYNE DONE 22/05/2018",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "JOHNNY NICHOLSON",
    "GBContact": "0212 121 998",
    "GB": "",
    "CustomerEmail": "CHRIS",
    "GBStart": "0212 121 998",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 43,
    "Received": "26/04/2018",
    "Address": "LOT 4, 80 SQUADRON DRIVE, HOB",
    "Issue": "Rodney",
    "Installer": "CARPET PULLING UP - ROSS BOOKED MON 21/05/2018 8.30AM",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": "021-070 3962",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "KIRSTY",
    "GBStart": "021-070 3962",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 55,
    "Received": "7/05/2018",
    "Address": "LOT 15, 2 CHAFFINCH RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "FIX CARPET LEADING FROM BEDROOM TO ENSUITE ROSS BOOKED TO FIX 11/05/2018",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "GRANT",
    "GBContact": "021 824 933",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "MARIA",
    "GBStart": "021 824 933",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/05/2018",
    "Address": "10 RANGIHINA RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "COMPLETED BY ROSS",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": 211714390,
    "GB": "",
    "CustomerEmail": "JO",
    "GBStart": 211714390,
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 59,
    "Received": "15/05/2018",
    "Address": "51 MAPOU RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CARPET IS LIFTING IN 2 AREAS- ROSS TO FIX 16/05/2018",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "",
    "GBContact": 21622004,
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "Karen",
    "GBStart": 21622004,
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 6,
    "Received": "17/04/2018",
    "Address": "LOT 6, TONAR ST",
    "Issue": "Central",
    "Installer": "JOINS (Rommel still to do) - NEED TO CHECK WITH KELVIN",
    "CustomerName": "UNIVERSAL HOMES",
    "CustomerPhone": "KELVIN AND BOYS",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 88,
    "Received": "26/06/2018",
    "Address": "49 ANDREW JACK RD , SILVERDALE",
    "Issue": "Rodney",
    "Installer": "COMPLETED 03/07/2018  CHARGE OUT!!!!!!!!",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "021 615 865",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "SHAUN",
    "GBStart": "021 615 865",
    "Status": "",
    "Notes": "IAN DONACHIE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 59,
    "Received": "11/05/2018",
    "Address": "lot 11,22 PAETAHI LANE",
    "Issue": "Central",
    "Installer": "RESILICON VINYL COVE BY SHOWER KANE TO FIX",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "021 588 591",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "021 588 591",
    "Status": "",
    "Notes": "REECE BAKER 021-588 591",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 65,
    "Received": "25/05/2018",
    "Address": "LOT 54, 73 ANDREW JACK RD SILVERDALE",
    "Issue": "Rodney",
    "Installer": "FIX CARPET AT JUNCTION WITH TILES - ROSS BOOKED 9.30AM 11/06/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "GRANT",
    "GBContact": 274413144,
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "BRYAN",
    "GBStart": 274413144,
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 68,
    "Received": "29/05/2018",
    "Address": "19 SACRED KINGFISHER RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "IMPROVE JOIN, REMOVE TACKS AT TOP OF STAIRS",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": 212375894,
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "YUAN DAI",
    "GBStart": 212375894,
    "Status": "",
    "Notes": "DEAN HODGSON",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 57,
    "Received": "11/05/2018",
    "Address": "lot 13, 26 TONAR ST NORTHCOTE",
    "Issue": "Central",
    "Installer": "REPAIR VINYL COVING KANE TO FIX",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "REECE BAKER 021-588 591",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 69,
    "Received": "30/05/2018",
    "Address": "LOT 17, 109 HOBSONVILLE PT ROAD",
    "Issue": "Rodney",
    "Installer": "PREINSPECT REPAIRS  -  ROSS BOOKED WEDNESDAY 30/05/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "BRANDON LEE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 70,
    "Received": "30/05/2018",
    "Address": "LOT 16,  107 HOBSONVILLE PT ROAD",
    "Issue": "Rodney",
    "Installer": "PREINSPECT REPAIRS  -  ROSS BOOKED WEDNESDAY 30/05/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "BRANDON LEE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 81,
    "Received": "15/06/2018",
    "Address": "LOT 6, 3 CHAFFINCH RD HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "FIT CARPET IN ENTRY CUPBOARD",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "DEAN",
    "GBStart": "",
    "Status": "",
    "Notes": "DEAN HODGSON",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 82,
    "Received": "15/06/2018",
    "Address": "LOT 702, 23 HELENVALE CRES, POKENO",
    "Issue": "South    -   COLIN ADVISED 'ALL DONE'  27/06/2018",
    "Installer": "SHOWHOME - TRACK MARKS - ROSS SEND COMPLAINT FORM TO KARL - COLIN INSPECTING",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "TAINUI RICKARD",
    "GBContact": "09-415 2714",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "GRANT COUTTS",
    "GBStart": "09-415 2714",
    "Status": "",
    "Notes": "GRANT COUTTS",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 105,
    "Received": "27/08/2018",
    "Address": "LOT 17, 6 CHAFFINCH RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "2 X JOINS, FIX LUMP UNDER STEP 2 - ROSS TO CHECK 28/08/2018 3.30PM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "NORM HUNT",
    "GBContact": "027-892 7165",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "LYSHAAN",
    "GBStart": "027-892 7165",
    "Status": "",
    "Notes": "JOANNE BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 74,
    "Received": "7/06/2018",
    "Address": "11 MOA STONE RD, MILLWATER",
    "Issue": "Rodney",
    "Installer": "FIX LOOSE CARPET FAMILY AREA - ROSS INSPECTING 14/06/2018 9.00AM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "NORM HUNT",
    "GBContact": "027-654 9777",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "SOPO",
    "GBStart": "027-654 9777",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 63,
    "Received": "22/05/2018",
    "Address": "8 VUE TERRACE, MILLWATER",
    "Issue": "Rodney",
    "Installer": "2 JOINS IN LOUNGE CARPET STICKING UP - Grant fixing Saturday 26th May",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "GRANT",
    "GBContact": "027-591 9395",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "GARY",
    "GBStart": "027-591 9395",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 98,
    "Received": "26/07/2018",
    "Address": "LOT 40, 27 SALTMARSH ROAD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "REPLACEMENT/RELAY - SAT 08/09/2018 KELVIN - GB349",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "MATTHEW BUNN",
    "GBContact": "027-570 0480",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "STUART",
    "GBStart": "027-570 0480",
    "Status": "",
    "Notes": "JOANNE BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 64,
    "Received": "23/05/2018",
    "Address": "LOT 8, 44 ONEKIRITEA RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "FIX CARPET AT TOP OF STAIR RISER, CARPET AT LAUNDRY LOOSE ROSS BOOKED 8.30AM 25/05/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "KELVIN, ROBERT",
    "GBContact": "027-556 5300",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "GREG",
    "GBStart": "027-556 5300",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 103,
    "Received": "17/08/2018",
    "Address": "14 VUE TERRACE, SILVERDALE",
    "Issue": "Rodney",
    "Installer": "CARPET LIFTING AT ENTRANCE ROSS BOOKED TUES 21/08/2018 MID MORNING",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "KELS FLOORING",
    "GBContact": "027-551 7160",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "ADRIAN",
    "GBStart": "027-551 7160",
    "Status": "",
    "Notes": "JOANNE BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 71,
    "Received": "7/06/2018",
    "Address": "LOT 20, 3E KIOKIO ST, LONG BAY",
    "Issue": "Central",
    "Installer": "FIX LOOSE CARPET JOINS AT KITCHEN, LIVING AREA & BATHROOMS - ROSS BOOKED PM 07/06/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "MATTHEW BUNN",
    "GBContact": "022-586 6913",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "EMMA",
    "GBStart": "022-586 6913",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 91,
    "Received": "3/07/2018",
    "Address": "LOT 28, 31 MAPOU ROAD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CARPET AT STAIRS-ROSS BOOKED TO INSPECT THURSDAY 04/07/18 CLIENT REQUESTED NOT BEFORE 9.00AM!!!",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "AK FLOORING",
    "GBContact": "021-927 412",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "TONY",
    "GBStart": "021-927 412",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 2,
    "Received": "17/05/2018",
    "Address": "LOT 2, 31A CASTLEDINE CRES, GI",
    "Issue": "South",
    "Installer": "BUMPS IN CARPET -  ROSS !!!!! - COMPLETED THURSDAY 17/05/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "KELVIN",
    "GBContact": "021-623 009",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "JAN",
    "GBStart": "021-623 009",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 102,
    "Received": "7/08/2018",
    "Address": "47 ANDREW JACK ROAD, SILVERDALE",
    "Issue": "Rodney",
    "Installer": "3 X SQUEAKY AREAS ON UPSTAIRS CARPET -  (ROSS to go back Aug 21st, lift 3 bedrooms, cut out squeaks)",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "GRANT",
    "GBContact": "021-321 492",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "SIMON",
    "GBStart": "021-321 492",
    "Status": "",
    "Notes": "JOANNE BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 75,
    "Received": "8/06/2018",
    "Address": "LOT 31, 37 MAPOU RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "BDM CARPET NEEDS RELAYING AFTER BUILDER. BY 18/06/2018 CHARGE OUT! Ross DOING 25/06/2018 PM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "GRANT",
    "GBContact": "021-2209 9234",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "RACHEL",
    "GBStart": "021-2209 9234",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 87,
    "Received": "26/06/2018",
    "Address": "LOT 12, 3 ANDREW ROAD, SILVERDALE",
    "Issue": "Rodney",
    "Installer": "LOOSE & FRAYED CARPET AT KITCHEN JUNCTION ROSS BOOKED 9.00AM MON 02/07/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "CADDYSHACK",
    "GBContact": "021-176 3224",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "EMMA",
    "GBStart": "021-176 3224",
    "Status": "",
    "Notes": "KARA SMITH",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 49,
    "Received": "3/05/2018",
    "Address": "LOT 12, 52 ONEKIRITEA RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CARPET REPAIRS AFTER BUILDER HAS FINISHED   -  BOOKED IN 14/05/2018 NASH",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "021-073 4730",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "KATIE",
    "GBStart": "021-073 4730",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 96,
    "Received": "16/07/2018",
    "Address": "42 BOMB POINT DR, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CARPET IN DINING ROOM COMING APART AT JOIN-MATT WED 18/07/2018 9.30AM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "CADDY",
    "GBContact": "021-069 9889",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "BUNREANG",
    "GBStart": "021-069 9889",
    "Status": "",
    "Notes": "JOANNE BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 95,
    "Received": "10/07/2018",
    "Address": "LOT 3, 13 SPOTTED DOVE RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "FRAYED CARPET- ROSS BOOKED TUESDAY 10/07/2018 4.15PM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "MATTHEW",
    "GBContact": "021-044 2163",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "HELEN",
    "GBStart": "021-044 2163",
    "Status": "",
    "Notes": "IAN DONACHIE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 40,
    "Received": "20/04/2018",
    "Address": "LOT 2, 129 HOBSONVILLE PT RD",
    "Issue": "Rodney",
    "Installer": "CARPET ON STAIRS NEEDS FIXING WAYNE WED 16/05/2018",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "",
    "GBContact": "021-042 4214",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "AMY",
    "GBStart": "021-042 4214",
    "Status": "",
    "Notes": "KARA SMITH",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 83,
    "Received": "19/06/2018",
    "Address": "125 HOBSONVILLE RD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "CAREPT FIXING BACK AFTER SQUEAKY STAIR FIXED  -  CHARGE OUT JOB!!!ROSS BOOKED FRI 22/06/2018 4.00PM",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "KELVIN",
    "GBContact": "021-035 3678",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "JEN",
    "GBStart": "021-035 3678",
    "Status": "",
    "Notes": "IAN DONACHIE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 27,
    "Received": "17/04/2018",
    "Address": "LOT 11, 16-24 MERFIELD STREET, GI",
    "Issue": "Central",
    "Installer": "FIX VINYL KITCHEN FLOOR BUBBLING -JOB DONE???? JO TO CONFIRM. JO CONFIRMED DONE!",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "MARK FLEMMING",
    "GBContact": "021-0257 8660",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "KENNITH",
    "GBStart": "021-0257 8660",
    "Status": "",
    "Notes": "IAN DONACHIE",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/05/2017",
    "Address": "LOT 4/13 MELLING ST GLEN INNES",
    "Issue": "Central",
    "Installer": "CHECK SIDES OF STAIRS",
    "CustomerName": "UNIVERSAL",
    "CustomerPhone": "GARY",
    "GBContact": "",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "AB",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/03/2016",
    "Address": "127 Hobsonville Pt Rd",
    "Issue": "Carpet loose on stairs",
    "Installer": "",
    "CustomerName": "Tracy Knight",
    "CustomerPhone": "021 082 26071",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/04/2017",
    "Address": "127 Hobsonville Pt Rd",
    "Issue": "Fix Stairs",
    "Installer": "Andrew Walker",
    "CustomerName": "Tracey Lee",
    "CustomerPhone": "021 082 26071",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "26/04/2017",
    "Address": "127 Hobsonville Pt Rd",
    "Issue": "Fix Stairs",
    "Installer": "Andrew Walker",
    "CustomerName": "Tracey Lee",
    "CustomerPhone": "021 082 26071",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "18/08/2017",
    "Address": "7 Grut Greens Millwater",
    "Issue": "replace carpet & underlay in cupboard due to leak",
    "Installer": "Ross",
    "CustomerName": "Tracey",
    "CustomerPhone": "021 497 920",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/11/2017",
    "Address": "21 Tua Tua Rd Hobsonville",
    "Issue": "carpet needs gap stretched",
    "Installer": "Ross",
    "CustomerName": "Tony",
    "CustomerPhone": "0211 750 954",
    "GBContact": "Brandon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brandon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/11/2016",
    "Address": "4 Woodridge Dr Whangaparoa",
    "Issue": "refit carpet round tile remedial work",
    "Installer": "Ross",
    "CustomerName": "Tim Sweet",
    "CustomerPhone": "021 241 9480",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "8/08/2017",
    "Address": "3 Eric Farley Drive Huapai",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Tim & Megan Runnalls",
    "CustomerPhone": 278075080,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/03/2016",
    "Address": "36 Te Oneroa Way, Long Bay",
    "Issue": "Replace carpet with stain on it",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Tim",
    "CustomerPhone": "027 353 5961",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Spoke to Tim",
    "Notes": "Carpet on order 8th July. Tim not ready until 8th July",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E0134",
    "Received": "31/05/2016",
    "Address": "Superlot 36, Lot 11, 39 Liquidambar Drive",
    "Issue": "Refit loose carpet and tap smooth edge down in kids bedrooms and sliders",
    "Installer": "",
    "CustomerName": "Tim",
    "CustomerPhone": "0274 334 334",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "TBF 16/06/2016",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/04/2018",
    "Address": "LOT 44, 53 ANDREW JACK RD",
    "Issue": "RESTRETCH CARPET ON TRIM",
    "Installer": "ROSS",
    "CustomerName": "THOMAS",
    "CustomerPhone": "021-0290 3217",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "FIXED BY ROSS",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/02/2018",
    "Address": "18 Mollusc Rd Hobsonville",
    "Issue": "fix stairs",
    "Installer": "Ross",
    "CustomerName": "Teresa",
    "CustomerPhone": 221535041,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "9/09/2017",
    "Address": "20C Torrington Cres Glen Innes",
    "Issue": "join splitting",
    "Installer": "Kelvin",
    "CustomerName": "Terangi",
    "CustomerPhone": 2102677513,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Kelvin",
    "Notes": "Kelvin completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/02/2018",
    "Address": "7 Martingale Dr Kingseat",
    "Issue": "carpet lifting & reglue join",
    "Installer": "Ross",
    "CustomerName": "Tasha",
    "CustomerPhone": 211451293,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "15/11/2017",
    "Address": "9 Arrier Lane Millwater",
    "Issue": "inspect hump in carpet",
    "Installer": "Ross",
    "CustomerName": "Swamy Umar",
    "CustomerPhone": 224007416,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/11/2016",
    "Address": "11 Matua Rd Huapai",
    "Issue": "carpet lifting in lounge",
    "Installer": "Ross",
    "CustomerName": "Susan Renata",
    "CustomerPhone": "021 333 378",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/12/2017",
    "Address": "182 Hobsonville Pt Rd",
    "Issue": "Restretch stairs",
    "Installer": "Ross",
    "CustomerName": "Susan Dobbie-Ede",
    "CustomerPhone": "021 407 509",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/05/2017",
    "Address": "45 Manuel Rd Millwater",
    "Issue": "carpet lifting",
    "Installer": "",
    "CustomerName": "Sukh Singh",
    "CustomerPhone": "021 046 3664",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "sukhzkool@gmail.com",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "1/06/2017",
    "Address": "30 Pony Park Pl Beachlands",
    "Issue": "re-stretch with Darryl Church",
    "Installer": "",
    "CustomerName": "Sue McGrath",
    "CustomerPhone": "021 040 8742",
    "GBContact": "MavisTulima",
    "GB": "OMAHA HOLDINGS LTD",
    "CustomerEmail": "",
    "GBStart": "MavisTulima",
    "Status": "Fixed by Darryl",
    "Notes": "Darryl completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/03/2016",
    "Address": "lot 88 8D Huarahi Pai Rd",
    "Issue": "Check joins, layer changed cutting plan",
    "Installer": "Richard & Andrew",
    "CustomerName": "Sue Hellesoe",
    "CustomerPhone": "021 851135",
    "GBContact": "Dan Young Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Dan Young Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "8/03/2016",
    "Address": "15 Thornton Green Karaka",
    "Issue": "Stretch and refit in various places",
    "Installer": "",
    "CustomerName": "Sue",
    "CustomerPhone": "021 2525063",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "Universal",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/03/2016",
    "Address": "57 Barcliff Terrace Gulf Harbour",
    "Issue": "carpet lifting in places and cropping needed",
    "Installer": "",
    "CustomerName": "Sue",
    "CustomerPhone": "021 022 36866",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/02/2018",
    "Address": "2 Weta Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Sudesh",
    "CustomerPhone": "029 127 0327",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "30/08/2016",
    "Address": "Lot 21, 3 Mapou Rd Hobsonville",
    "Issue": "fraying and lifting round kitchen tiles, stair bubble, nap join",
    "Installer": "Ross",
    "CustomerName": "Stuart Tomlinson",
    "CustomerPhone": "021 837 863",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2016",
    "Address": "27 Saltmarsh Rd Hobsonville",
    "Issue": "re stretch carpet lifting at tiles and stretch stairs",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Stuart &Rene Hartley",
    "CustomerPhone": "021 570 478",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "stuart.hartley@mail.com",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2016",
    "Address": "27 Saltmarsh Rd Hobsonville",
    "Issue": "replace carpet lifting at tiles",
    "Installer": "Matt",
    "CustomerName": "Stuart &Rene Hartley",
    "CustomerPhone": "021 570 478",
    "GBContact": "Brad Small",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "stuart.hartley@mail.com",
    "GBStart": "Brad Small",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/12/2016",
    "Address": "27 Saltmarsh Rd Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "Matt",
    "CustomerName": "Stuart",
    "CustomerPhone": "021 570 478",
    "GBContact": "Brad Small",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brad Small",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/03/2018",
    "Address": "39 Ormonde Dr Millwater",
    "Issue": "refit lifting carpet",
    "Installer": "Ross",
    "CustomerName": "Straka",
    "CustomerPhone": 211571602,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 15,
    "Received": "17/04/2018",
    "Address": "45 HARRIS DRIVE, MILLWATER",
    "Issue": "Rodney",
    "Installer": "WATER LEAK FROM SHOWER - GB300 CARPET IN STORE  -  BOOK DAVE - COMPLETED",
    "CustomerName": "STONEWOOD",
    "CustomerPhone": "",
    "GBContact": "021-118 5241",
    "GB": "",
    "CustomerEmail": "JO",
    "GBStart": "021-118 5241",
    "Status": "",
    "Notes": "STONEWOOD",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 52,
    "Received": "7/05/2018",
    "Address": "11 JAVELIN CLOSE GULF HARBOUR",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "RE FIT CARPET AT ENSUITE DOOR FOLLOWING LEAK ROSS SIGHTING 10/05/2018 FIXED AND INVOICED",
    "CustomerName": "STONEWOOD",
    "CustomerPhone": "",
    "GBContact": "021 464 496",
    "GB": "",
    "CustomerEmail": "LORRAINE JONES",
    "GBStart": "021 464 496",
    "Status": "",
    "Notes": "ROSS MURRAY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "",
    "Address": "105 Karepiro Dr Stanmore Bay",
    "Issue": "Norm  Re did his join",
    "Installer": "Norm",
    "CustomerName": "Stevi",
    "CustomerPhone": "021 081 05 801",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Norm Hunt",
    "Notes": "Norm  completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/05/2017",
    "Address": "225 Wainui Rd Millwater",
    "Issue": "Tuck carpet into smoothedge behind door",
    "Installer": "",
    "CustomerName": "Steven Bradshaw",
    "CustomerPhone": 278078131,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/10/2016",
    "Address": "lot 147,10 Eric Farley Drive Huapai",
    "Issue": "Refit to wall and tile",
    "Installer": "Ross",
    "CustomerName": "Steve Robinson",
    "CustomerPhone": 272016651,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/04/2017",
    "Address": "221 Wainui Rd Silverdale",
    "Issue": "inspect discoloured carpet/install issues",
    "Installer": "Matt Bunn",
    "CustomerName": "Stephen Arnott",
    "CustomerPhone": "021 830 026",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/06/2017",
    "Address": "221 Wainui Rd Silverdale",
    "Issue": "Refit and join carpet",
    "Installer": "Matt Bunn",
    "CustomerName": "Stephen Arnott",
    "CustomerPhone": "021 830 026",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "25/01/2018",
    "Address": "221 Wainui Rd Silverdale",
    "Issue": "carpet lifting",
    "Installer": "Matt Bunn",
    "CustomerName": "Stephen Arnott",
    "CustomerPhone": "021 830 026",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "30/01/2018",
    "Address": "17 Spotted Dove Rd Hobsonville",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Stephanie",
    "CustomerPhone": 21515130,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "13/10/2016",
    "Address": "68 Timberland Dr Millwater",
    "Issue": "Refit to walls where lifting",
    "Installer": "Ross",
    "CustomerName": "Stephan Potgieter",
    "CustomerPhone": "027 838 6131",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "5/07/2016",
    "Address": "102 Hillpark Dr Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Stacey Hartshorne",
    "CustomerPhone": 272799225,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2018",
    "Address": "`17 O'Ruamano Cres Puke",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Siraj",
    "CustomerPhone": 277427017,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "18/11/2016",
    "Address": "75C Martyn St Waiuku",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Darryl",
    "CustomerName": "Simon Williams",
    "CustomerPhone": "027 455 0443",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/10/2017",
    "Address": "47 Andrew Jack Rd",
    "Issue": "Check join.",
    "Installer": "",
    "CustomerName": "Simon",
    "CustomerPhone": "021 321 492",
    "GBContact": "Morne Botha Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Morne Botha Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/01/2018",
    "Address": "47 Andrew Jack Rd",
    "Issue": "Check join.",
    "Installer": "",
    "CustomerName": "Simon",
    "CustomerPhone": "021 321 492",
    "GBContact": "Morne Botha Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Morne Botha Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/11/2017",
    "Address": "4 Skylark Rd Hobsonville",
    "Issue": "refit carpet after repairs",
    "Installer": "Ross",
    "CustomerName": "Shivaun",
    "CustomerPhone": 212330534,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "23/06/2016",
    "Address": "202 Hobsonville Point Road",
    "Issue": "Relay carpet to middle level stairs and Bed2 following squeak fix. Keith (builder) 021 112 0967",
    "Installer": "",
    "CustomerName": "Sheila + Tim Chen",
    "CustomerPhone": "021 173 4058",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "pending Keith",
    "Notes": "Keith in 6/7 July to fix floor, will be in touch",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "8/09/2016",
    "Address": "202Hobsonville Point Road",
    "Issue": "ADVISED Ian need to go back when squeaky floor fixed",
    "Installer": "Ross",
    "CustomerName": "Sheila",
    "CustomerPhone": 211734058,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "12/04/2017",
    "Address": "202Hobsonville Point Road",
    "Issue": "ADVISED Ian need to go back when squeaky floor fixed",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Sheila",
    "CustomerPhone": 211734058,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": 323247,
    "Received": "22/04/2016",
    "Address": "Lot 53, 18 Malbec Place, Huapai",
    "Issue": "Remove object under carpet in main bedroom",
    "Installer": "George",
    "CustomerName": "Sharon Walton",
    "CustomerPhone": "021 356 009",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "unknown",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/03/2016",
    "Address": "139 Hillpark Dr Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Shaney Anderson",
    "CustomerPhone": "027 447 0105",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/06/2017",
    "Address": "8 Skipjack Pass Millwater",
    "Issue": "repair water damaged carpet",
    "Installer": "",
    "CustomerName": "Shalini",
    "CustomerPhone": "021 231 6632",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": 58,
    "Received": "11/05/2018",
    "Address": "45 BOUNTY RD, LONG BAY",
    "Issue": "Central",
    "Installer": "JOIN AFTER REPAIR WORK NOT ACCEPTABLE - KELVIN HAS PAPER WORK THURSDAY 31/05/2018",
    "CustomerName": "SENTINEL",
    "CustomerPhone": "KELVIN",
    "GBContact": "027-552 3333",
    "GB": "SENTINEL HOMES",
    "CustomerEmail": "KYLIE",
    "GBStart": "027-552 3333",
    "Status": "",
    "Notes": "SENTINEL",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 33,
    "Received": "12/07/2018",
    "Address": "15 KAHIKA GROVE HUAPAI",
    "Issue": "Rodney",
    "Installer": "ROSS VIEWED 11/07/2018 - KELVIN TO RETURN AND FIX ISSUES  WED am JULY 25th",
    "CustomerName": "SENTINEL",
    "CustomerPhone": "KELVIN MARCH 2017",
    "GBContact": "021 266 8847",
    "GB": "SENTINEL HOMES",
    "CustomerEmail": "GEMMA",
    "GBStart": "021 266 8847",
    "Status": "",
    "Notes": "HILTON BARTHOLOMEW",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 33,
    "Received": "17/04/2018",
    "Address": "15 KAHIKA GROVE HUAPAI",
    "Issue": "Rodney",
    "Installer": "CARPET ISSUES 26/4/18 ROSS FIXED ALL ISSUES EXCEPT FLOOR NEEDS FIXING SENTINEL - 16/05/2018 HILTON CANCELLED. ROSS DOING 3.00PM 29/05/2018",
    "CustomerName": "SENTINEL",
    "CustomerPhone": "",
    "GBContact": "021 266 8847",
    "GB": "SENTINEL HOMES",
    "CustomerEmail": "GEMMA",
    "GBStart": "021 266 8847",
    "Status": "",
    "Notes": "HILTON BARTHOLOMEW",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/05/2017",
    "Address": "7 Moho Lane Takanini",
    "Issue": "relay flood damaged carpet",
    "Installer": "",
    "CustomerName": "Sarah Naidu",
    "CustomerPhone": "021 486 536",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "2/08/2017",
    "Address": "22 Ara Kakara Ave Huapai",
    "Issue": "refit carpet where lifting",
    "Installer": "",
    "CustomerName": "Sarah",
    "CustomerPhone": "021 0227 5242",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "29/11/2017",
    "Address": "12 Belvedere Place, Warkworth",
    "Issue": "staple all tile transitions",
    "Installer": "Ross",
    "CustomerName": "Sarah",
    "CustomerPhone": "",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/09/2016",
    "Address": "Rohae Pl Papakura",
    "Issue": "Napped and flattened join",
    "Installer": "Ross",
    "CustomerName": "Sampayo",
    "CustomerPhone": 221797646,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/03/2016",
    "Address": "170 Hobsonville Pt Rd",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Sam",
    "CustomerPhone": "027 807 8885",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/01/2017",
    "Address": "1 Captain Mitchell Dr Papakura",
    "Issue": "loose s/e and lump under carpet",
    "Installer": "Ross",
    "CustomerName": "Sally Dunphy",
    "CustomerPhone": 211810995,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/03/2018",
    "Address": "79 Andrew Jack Rd",
    "Issue": "trim tufts",
    "Installer": "Ross",
    "CustomerName": "Sagan",
    "CustomerPhone": "",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/11/2016",
    "Address": "6 Leadership Cres Addison",
    "Issue": "Check fault and hump in floor",
    "Installer": "Darryl",
    "CustomerName": "Ryan Morris",
    "CustomerPhone": "02103222089 Suzi",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "suzi.im25@gmail.com",
    "GBStart": "Meridith Gilmour",
    "Status": "",
    "Notes": "Darryl to inspect",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "21/03/2016",
    "Address": "38 Tuatua Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Rowan Bezuidenhout",
    "CustomerPhone": "021 254 1989",
    "GBContact": "Brad White (Uni)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brad White (Uni)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/07/2017",
    "Address": "13 Mapou Rd Hobsonville",
    "Issue": "Fix stairs etc",
    "Installer": "Gabe",
    "CustomerName": "Rosie",
    "CustomerPhone": 273005497,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "15/06/2017",
    "Address": "15 Kahika Grove Huapai",
    "Issue": "attend to join",
    "Installer": "",
    "CustomerName": "Roger MacKellow",
    "CustomerPhone": 223130908,
    "GBContact": "Roger MacKellow",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Roger MacKellow",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/04/2017",
    "Address": "219 Wainui Rd Silverdale",
    "Issue": "lift carpet for floor remedial& return to refit",
    "Installer": "",
    "CustomerName": "Roger Lan",
    "CustomerPhone": "021 037 6846",
    "GBContact": "Universal Dean",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Dean",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/09/2017",
    "Address": "227 Wainui Rd Silverdale",
    "Issue": "Refit and join carpet",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Robbie",
    "CustomerPhone": "021 2094220",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "29/03/2016",
    "Address": "15 Magnolia Lane Kaukapakapa",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Rob & Kaye Gunston",
    "CustomerPhone": 226809392,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/05/2016",
    "Address": "15 Magnolia Lane Kaukapakapa",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Rob & Kaye Gunston",
    "CustomerPhone": 226809392,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/04/2017",
    "Address": "49 Clemows Lane Albany FX client",
    "Issue": "restretch main bedroom",
    "Installer": "Ross",
    "CustomerName": "RM Power",
    "CustomerPhone": "027 216 5579",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "rmpower@xtra.co.nz",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "8/03/2018",
    "Address": "26 Rosalind Rd Glenfield",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Richard",
    "CustomerPhone": "021 683 054",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/03/2018",
    "Address": "12B Dida Park Ave Huapai",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Richard",
    "CustomerPhone": 211408880,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/01/2017",
    "Address": "15 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Rebekah Hooker",
    "CustomerPhone": 223773154,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/01/2017",
    "Address": "17 Swindon Close Mellons Bay",
    "Issue": "carpet needs restretch all over #830347",
    "Installer": "Ross",
    "CustomerName": "Rebecca Charlton",
    "CustomerPhone": 21673671,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "findbecs@yahoo.com",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/05/2017",
    "Address": "21 Rahotu Way Glenfield",
    "Issue": "re-stretch",
    "Installer": "",
    "CustomerName": "Ray mathews",
    "CustomerPhone": "",
    "GBContact": "Universal Dean",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Dean",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/05/2017",
    "Address": "2 Huarahi Pai Rd",
    "Issue": "staple all tile transitions",
    "Installer": "",
    "CustomerName": "Ray",
    "CustomerPhone": "022 414 0041",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/12/2016",
    "Address": "3 Cornwall Pl Karaka",
    "Issue": "restretch whole house",
    "Installer": "Ross& Johnny",
    "CustomerName": "Raphael",
    "CustomerPhone": "027 7050878",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/02/2017",
    "Address": "19 Tennessee Rd Mangere",
    "Issue": "hit down smoothedge",
    "Installer": "Ross",
    "CustomerName": "Raj Prasad",
    "CustomerPhone": "",
    "GBContact": "Mavis GJ",
    "GB": "OMAHA HOLDINGS LTD",
    "CustomerEmail": "",
    "GBStart": "Mavis GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/08/2017",
    "Address": "28 Outlook Terrace",
    "Issue": "tighten stairs",
    "Installer": "Ross",
    "CustomerName": "Rachel Atkinson",
    "CustomerPhone": "021 231 7073",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/09/2016",
    "Address": "28 Outlook Terrace",
    "Issue": "Bubbling Stairs",
    "Installer": "Darryl",
    "CustomerName": "Rachel",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "GB024",
    "Received": "30/06/2016",
    "Address": "Lot 15, 47 Liquidambar Dr Hobsonville",
    "Issue": "Refit carpet to stair treads before mid level landing",
    "Installer": "Matt",
    "CustomerName": "PM Delyse - 021 752 823. Tenant Kathleen - 021 128 1303",
    "CustomerPhone": "",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "TBF 5/7/16",
    "Notes": "Tenant moves in on 7th July",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/06/2016",
    "Address": "Lot 15, 47 Liquidambar Dr Hobsonville",
    "Issue": "Refit carpet to stair treads before mid level landing",
    "Installer": "Matt",
    "CustomerName": "PM Delyse - 021 752 823. Tenant Kathleen - 021 128 1303",
    "CustomerPhone": "",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "TBF 5/7/16",
    "Notes": "Tenant moves in on 7th July",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "1/06/2017",
    "Address": "33 Headland Dr Long Bay",
    "Issue": "carpet lifting",
    "Installer": "",
    "CustomerName": "Pia Wellingham",
    "CustomerPhone": "021 445 685",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/07/2017",
    "Address": "33 Headland Dr Long Bay",
    "Issue": "refit carpet and new smoothedge",
    "Installer": "",
    "CustomerName": "Pia Wellingham",
    "CustomerPhone": "021 445 685",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "7/10/2016",
    "Address": "28 Te Oneroa Way",
    "Issue": "Carpet loose on stairs",
    "Installer": "Ross",
    "CustomerName": "Pia",
    "CustomerPhone": "021 445 685",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/02/2018",
    "Address": "97 Glidepath Rd Hobsonville",
    "Issue": "carpet short up to tiles",
    "Installer": "Ross",
    "CustomerName": "Phillip Terris",
    "CustomerPhone": "021 073 7977",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "46 Onekiritea Rd Hobsonville",
    "Issue": "carpet short in lg",
    "Installer": "Rommel & Robert",
    "CustomerName": "Paul Westwood",
    "CustomerPhone": "022 4050709 Lauren",
    "GBContact": "Lauren (Uni)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Lauren (Uni)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/04/2017",
    "Address": "74 Caldera Dr Long Bay",
    "Issue": "repair carpet at stairs and refit to tiles",
    "Installer": "Ross",
    "CustomerName": "Paul Farnan",
    "CustomerPhone": 21648497,
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "24/03/2016",
    "Address": "23 Barcliff Terrace Gulf Harbour",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Paul Doesburg",
    "CustomerPhone": "021 0296 9142",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/02/2016",
    "Address": "1722 East Coast Rd Kaiaua",
    "Issue": "refit bar at kitchen",
    "Installer": "Ross",
    "CustomerName": "Paul Cronin GJ",
    "CustomerPhone": "021 846 909",
    "GBContact": "Paul Cronin",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Paul Cronin",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/04/2017",
    "Address": "43 Andrew Jack Rd Silverdale",
    "Issue": "Fix Stairs and carpet lifting",
    "Installer": "Gabe",
    "CustomerName": "Paul Chapman",
    "CustomerPhone": "021 235 3968",
    "GBContact": "Universal Dean",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Dean",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/01/2018",
    "Address": "6 Ara Kakara Ave Huapai",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Patricia",
    "CustomerPhone": 211784880,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/06/2017",
    "Address": "5 Touhou Rd Hobsonville",
    "Issue": "Fix lump in stair",
    "Installer": "",
    "CustomerName": "Olivia",
    "CustomerPhone": "021 397 700",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/07/2017",
    "Address": "29 Andrew Jack Rd Silverdale",
    "Issue": "refit carpet under breakfast bar",
    "Installer": "",
    "CustomerName": "Oleg Bogomazov",
    "CustomerPhone": "021 105 2694",
    "GBContact": "Universal Tony",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Tony",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/03/2016",
    "Address": "95 Hamilton Rd Snells Beach",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Nyal Grant",
    "CustomerPhone": "021 757 988",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/06/2016",
    "Address": "578 Harris Drive",
    "Issue": "Bedroom uplifted, needs relaying",
    "Installer": "",
    "CustomerName": "None",
    "CustomerPhone": "None",
    "GBContact": "Paul Withers",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "paulw@universal.co.nz",
    "GBStart": "Paul Withers",
    "Status": "TBF 10/6/16",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/01/2017",
    "Address": "11B Riversdale Rd Avondale",
    "Issue": "Fit carpet to trims",
    "Installer": "Ross",
    "CustomerName": "Nick Pearson",
    "CustomerPhone": 21478852,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/10/2016",
    "Address": "280 Trig Rd Whitford",
    "Issue": "Stairs",
    "Installer": "Ross",
    "CustomerName": "Nick & Claire Grant",
    "CustomerPhone": "021 227 5118",
    "GBContact": "Christian",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Christian",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/01/2018",
    "Address": "93 Hillpark Dr Pokeno",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Nelly",
    "CustomerPhone": 210543529,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "5/07/2016",
    "Address": "10 Provence Esplanade, Te Atatu",
    "Issue": "Tuck carpet into smooth",
    "Installer": "Ross",
    "CustomerName": "Navin",
    "CustomerPhone": "021 839 780",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "grant e-mail",
    "Notes": "Pending contact with Ross",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/09/2017",
    "Address": "17 Saltmarsh Rd Hobsonville",
    "Issue": "tuck in stairs",
    "Installer": "Ross",
    "CustomerName": "Natalie",
    "CustomerPhone": 211940434,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "18/11/2016",
    "Address": "lot 13 47 Yates Rd Mangere",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "Naresh",
    "CustomerPhone": 221858193,
    "GBContact": "Ryan Meynell",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Ryan Meynell",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/06/2016",
    "Address": "47 Madison Tce, Millwater",
    "Issue": "Replace removed carpet from cupboard after flood. Carpet in garage",
    "Installer": "",
    "CustomerName": "Nancy Zhang",
    "CustomerPhone": "021 801 926",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "TBF 21/6/16 9:30",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/02/2016",
    "Address": "40 Outlook Tce Millwater",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Mr Cochrane",
    "CustomerPhone": "021 337 734",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/02/2017",
    "Address": "32 Beachwood Drive Hatfields Beach",
    "Issue": "re-stretch",
    "Installer": "Ross",
    "CustomerName": "Mr & Mrs Ball (GJ Clients)",
    "CustomerPhone": "021 131 8101",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/06/2017",
    "Address": "47 Mapou Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Moore",
    "CustomerPhone": 21478113,
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "11/07/2017",
    "Address": "47 Mapou Rd Hobsonville",
    "Issue": "refit flooded carpet",
    "Installer": "",
    "CustomerName": "Moore",
    "CustomerPhone": 21478113,
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "26/01/2017",
    "Address": "46 Moira Drive Tuakau",
    "Issue": "Carpet worn badly for being installed 1yr underlay faulty",
    "Installer": "Ross",
    "CustomerName": "Monique Francis",
    "CustomerPhone": 211547456,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Inspected by Ross",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/08/2017",
    "Address": "20E Merfield St GI",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Monique",
    "CustomerPhone": "021 02008292",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/07/2017",
    "Address": "192 Hobsonville Pt Rd",
    "Issue": "Restretch stairs",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Mitchell Nook",
    "CustomerPhone": 223540116,
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/12/2016",
    "Address": "3/15 Sprott Rd",
    "Issue": "refit carpet where lifting",
    "Installer": "Ross",
    "CustomerName": "Mike Maloney",
    "CustomerPhone": "021 777 303",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 22741,
    "Received": "15/04/2016",
    "Address": "3 McCall Drive, Waiuku",
    "Issue": "Carpet lifting in hallway",
    "Installer": "Darryll",
    "CustomerName": "Michelle Lennard",
    "CustomerPhone": "021 128 7964",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 16/05/16",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": 42571,
    "Address": "72 Eighth View Ave, Beachlands",
    "Issue": "Kick carpet onto smoothedge at ensuite door",
    "Installer": "Kelvin/Darryl",
    "CustomerName": "Michele Matheson",
    "CustomerPhone": "021 474 221- 9787080",
    "GBContact": "GJ Angela Munro",
    "GB": "",
    "CustomerEmail": "mikeandmichelle@vodafone.co.nz",
    "GBStart": "GJ Angela Munro",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/11/2017",
    "Address": "4 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Michael(Tenant)",
    "CustomerPhone": 277273018,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/06/2017",
    "Address": "12 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Michael(Tenant)",
    "CustomerPhone": "",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/04/2017",
    "Address": "168 Hobsonville Pt Rd",
    "Issue": "repair lg floor and relay",
    "Installer": "Andrew Walker",
    "CustomerName": "Michael Brecknell",
    "CustomerPhone": 212633142,
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/07/2016",
    "Address": "Lot1 15 Turua Rise Karaka",
    "Issue": "Knock down pins  and scrape paint from carpet",
    "Installer": "Ross",
    "CustomerName": "Melissa Mills",
    "CustomerPhone": "021 402 402",
    "GBContact": "Universal Dean",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Dean",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/12/2016",
    "Address": "16 Tuatua Rd Hobsonville",
    "Issue": "hit down smoothedge on stairs",
    "Installer": "Ross",
    "CustomerName": "Melissa Lou",
    "CustomerPhone": "",
    "GBContact": "Damon Hoskins",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Damon Hoskins",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E0060",
    "Received": 42514,
    "Address": "3 Floyd Road, Riverhead",
    "Issue": "Edges coming up and vinyl adhesive left on top of joins",
    "Installer": "Dave Walker",
    "CustomerName": "Melissa",
    "CustomerPhone": "021 0279 7058",
    "GBContact": "Brett Lennon",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett Lennon",
    "Status": "TBF 1.06.16",
    "Notes": "1-130pm check vinyl planks take photos. Naplock is dented, require replacement.",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E8871",
    "Received": "30/05/2016",
    "Address": "5 Portofino Point Karaka",
    "Issue": "Carpet lifting in hallway",
    "Installer": "Matt",
    "CustomerName": "Megren",
    "CustomerPhone": "021 45 747 8",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 02.05.16",
    "Notes": "TBF Thur 2nd 4pm",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/03/2018",
    "Address": "37 Resolution Dr Gulf Harbour",
    "Issue": "carpet lifting at tiles and joins",
    "Installer": "Ross",
    "CustomerName": "Meghan Heaney",
    "CustomerPhone": "021 180 3462",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/03/2018",
    "Address": "20 Mollusc Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Megan",
    "CustomerPhone": 211143300,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "22/03/2016",
    "Address": "36 Tuatua Rd Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Max Wong",
    "CustomerPhone": "022 360 6128",
    "GBContact": "Brad Small Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brad Small Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "12/09/2017",
    "Address": "21 Park Grove Cr Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Matthew Mowbray",
    "CustomerPhone": 21810440,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "1/06/2017",
    "Address": "60 Seventh View Ave Beachlands",
    "Issue": "re-fit popped smoothedge",
    "Installer": "Darryl",
    "CustomerName": "Matt & Alicia Pratt",
    "CustomerPhone": "021 379 813 Matt",
    "GBContact": "MavisTulima",
    "GB": "OMAHA HOLDINGS LTD",
    "CustomerEmail": "",
    "GBStart": "MavisTulima",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/04/2017",
    "Address": "5 Arriere Lane Millwater",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Maryanne",
    "CustomerPhone": "027 445 2423",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "18/08/2017",
    "Address": "84 Squadron Dr Hobsonville",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Mark Minors",
    "CustomerPhone": "021 1083477",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/03/2018",
    "Address": "17 Arrier Lane Millwater",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Marj Noble",
    "CustomerPhone": "021 711 540",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/04/2017",
    "Address": "29 Saltmarsh Rd Hobsonville",
    "Issue": "Refit carpet and small amount levelling",
    "Installer": "Matt",
    "CustomerName": "Marissa",
    "CustomerPhone": "021 025 46813",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Matt",
    "Notes": "Matt completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "14/06/2017",
    "Address": "36 Doment Cr Orewa",
    "Issue": "Johnny to powerstretch carpet to naplock",
    "Installer": "Kelvin",
    "CustomerName": "Marie Hansen",
    "CustomerPhone": 276638696,
    "GBContact": "Marie(Uni)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Marie(Uni)",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/04/2017",
    "Address": "36 Doment Cr Orewa",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Marie Hansen",
    "CustomerPhone": 21998301,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 3011,
    "Received": 42508,
    "Address": "12 Pitoitoi Drive, Riverhead",
    "Issue": "Foul smell eminating from corner of room. Uplift carpet and relay once issue resolved",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Marie",
    "CustomerPhone": "027 243 0300",
    "GBContact": "Brett Lennon",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett Lennon",
    "Status": "TBF 3.06.16",
    "Notes": "Andy Belcher - Builder repairing wall, not ready until Wed 1st. 027525 9799",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "9/05/2016",
    "Address": "11 Remana Crescent, Huapai",
    "Issue": "Two walls have been fixed, replacement from lift",
    "Installer": "Matthew",
    "CustomerName": "Maria",
    "CustomerPhone": "021 261 5206",
    "GBContact": "Brett Lennon",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett Lennon",
    "Status": "11/05/2016",
    "Notes": "Johnny to fix",
    "Advised": "",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "20/09/2017",
    "Address": "20 Fermier Greens",
    "Issue": "trim carpet",
    "Installer": "Ross",
    "CustomerName": "Marcola Oliver",
    "CustomerPhone": 223509389,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/06/2017",
    "Address": "Hull Rd Waitoki",
    "Issue": "lay carpet up to laminate",
    "Installer": "",
    "CustomerName": "Mandy Mitten",
    "CustomerPhone": "021 618 775",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 89,
    "Received": "28/06/2018",
    "Address": "11 FLOYD ROAD, RIVERHEAD",
    "Issue": "Rodney",
    "Installer": "REPAIR/FIX CARPET AFTER LEAK - ROSS BOOKED THURSDAY 3.30PM 28/06/2018",
    "CustomerName": "MADISON PARK HOMES LTD",
    "CustomerPhone": "",
    "GBContact": "021-264 6036",
    "GB": "",
    "CustomerEmail": "CLAIRE",
    "GBStart": "021-264 6036",
    "Status": "",
    "Notes": "ROSS MURRAY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "EO122",
    "Received": "3/08/2016",
    "Address": "38 Liquidambar Dr Hobsonville",
    "Issue": "tidy up all areas, need to go back grind concrete+cupboard re layed",
    "Installer": "Andrew",
    "CustomerName": "Lyshan Bailey",
    "CustomerPhone": 21819768,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "ross doing 3/8/16",
    "Notes": "All completed except for grind concrete",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "EO122",
    "Received": "23.3.2017",
    "Address": "38 Liquidambar Dr Hobsonville",
    "Issue": "carpet lifting on stairs",
    "Installer": "Andrew",
    "CustomerName": "Lyshan Bailey",
    "CustomerPhone": 21819768,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/09/2017",
    "Address": "91 Valley Rd Pukekohe",
    "Issue": "refit lifting carpet",
    "Installer": "Ross",
    "CustomerName": "Lynn",
    "CustomerPhone": 272977419,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/03/2016",
    "Address": "16 Whaley Greens Millwater",
    "Issue": "restretch stairs",
    "Installer": "Kelvin",
    "CustomerName": "Lusher",
    "CustomerPhone": "0224 782706",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "6/04/2018",
    "Address": "3C Kiokio St Long Bay",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Luong",
    "CustomerPhone": "021 680 386",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "22/08/2017",
    "Address": "37 Ormonde Dr Millwater",
    "Issue": "refit lifting carpet",
    "Installer": "Ross",
    "CustomerName": "Luke",
    "CustomerPhone": "021 052 8137",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/06/2017",
    "Address": "84 Caldera Dr Long Bay",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Lucinda",
    "CustomerPhone": "021 028 21488",
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2016",
    "Address": "1 Resolution Dr Fairway Bay",
    "Issue": "join new carpet to doorway",
    "Installer": "Dave",
    "CustomerName": "Louis & Stacey Nel",
    "CustomerPhone": 212775445,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Dave",
    "Notes": "Dave completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/06/2016",
    "Address": "30 Tuatua Rd Hobsonville",
    "Issue": "refit carpet lifted",
    "Installer": "",
    "CustomerName": "Lossie",
    "CustomerPhone": "021 240 8383",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/03/2018",
    "Address": "18 Raithburn Terrace Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Lindsey",
    "CustomerPhone": "0275 991 254",
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 830449,
    "Received": "1/04/2016",
    "Address": "8 Artists Ave, Beachlands",
    "Issue": "Pins felt through carpet in numerous areas",
    "Installer": "Kelvin",
    "CustomerName": "Lindsay",
    "CustomerPhone": "021 398 925",
    "GBContact": "Soane Wainiqolo",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Soane Wainiqolo",
    "Status": "TBF 20/6/16 930am",
    "Notes": "GJ's to do work before FJ. Lift and replace. - Extra FJ work than listed on this order. Work done, carpet to be relaid",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/07/2017",
    "Address": "9A Routley Ave Pukekohe",
    "Issue": "carpet badly fading under mat",
    "Installer": "Darryl",
    "CustomerName": "Linda Chapman",
    "CustomerPhone": 226351980,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "2/06/2017",
    "Address": "5 Mapou Rd Hobsonville",
    "Issue": "carpet lifting in several areas + stairs",
    "Installer": "",
    "CustomerName": "Lianne Maude",
    "CustomerPhone": "021 875 454",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/11/2017",
    "Address": "24 Eric Farley Drive Huapai",
    "Issue": "refit lifting carpet",
    "Installer": "Ross",
    "CustomerName": "Les Gates",
    "CustomerPhone": 21353160,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/06/2017",
    "Address": "199 Wainui Rd Silverdale",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Lee",
    "CustomerPhone": 212346906,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "8/06/2017",
    "Address": "8B Huarahi Pai Rd Huapai",
    "Issue": "relay flood damaged carpet",
    "Installer": "",
    "CustomerName": "Lee",
    "CustomerPhone": "021 079 6710",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "12/09/2017",
    "Address": "13 Captain Mitchell Drive Papakura",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Latham(Tenant)",
    "CustomerPhone": 275252810,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "29/04/2017",
    "Address": "16 Riverleigh Dr Snells Beach",
    "Issue": "Flood damage, suggested clean/insurance claim",
    "Installer": "",
    "CustomerName": "Lance Moncrieff",
    "CustomerPhone": "027 4444 257",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "EO258",
    "Received": "27/07/2016",
    "Address": "Lot 12, 32 Capriole Cres Karaka",
    "Issue": "Join in Lounge",
    "Installer": "Darryl",
    "CustomerName": "Lachlan Downing",
    "CustomerPhone": "0275 388948",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "meridith.gilmour@gjgardner.co.nz",
    "GBStart": "Meridith Gilmour",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 22815,
    "Received": "9/05/2016",
    "Address": "17 Captain Mitchell Drive, Papakura",
    "Issue": "Carpet lifting by ranch slider in hallway",
    "Installer": "Kelvin",
    "CustomerName": "Krishna",
    "CustomerPhone": "021 0827 5847",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 13/05/16",
    "Notes": "Elderly woman home all day",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/08/2017",
    "Address": "80 Squadron Dr Hobsonville",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Kirsty-Lee Venter",
    "CustomerPhone": "021 070 3962",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/04/2017",
    "Address": "80 Squadron Dr",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Kirsty Lee-Venter",
    "CustomerPhone": "",
    "GBContact": "Damon Hoskins Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Damon Hoskins Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "",
    "Address": "2 Beacon Rd Riverhead",
    "Issue": "Lump under carpet in underlay",
    "Installer": "Ross",
    "CustomerName": "Kirsty",
    "CustomerPhone": "021 033 4307",
    "GBContact": "GJ Kim Ardin",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "GJ Kim Ardin",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/06/2017",
    "Address": "14 Artist Ave Beachlands",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Kirstine Kelly",
    "CustomerPhone": "0274 402200",
    "GBContact": "Mavis GJ",
    "GB": "OMAHA HOLDINGS LTD",
    "CustomerEmail": "",
    "GBStart": "Mavis GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E7752",
    "Received": "30/05/2016",
    "Address": "8 Cottage Court",
    "Issue": "Walls have been moved and missing two planks. Ghost gum",
    "Installer": "",
    "CustomerName": "Kieran",
    "CustomerPhone": "021 115 5309",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 20/6/16 12pm",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/03/2016",
    "Address": "8Aro Mato Pl Huapai",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Ki&Hoonjong Lee",
    "CustomerPhone": 21533797,
    "GBContact": "Dan Young Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Dan Young Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "5/04/2016",
    "Address": "8 Aro Mato Pl Huapai",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Ki&Hoonjong Lee",
    "CustomerPhone": 21533797,
    "GBContact": "Dan Young Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Dan Young Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/04/2017",
    "Address": "25 Liquidambar Dr Hobsonville",
    "Issue": "Fix Stairs",
    "Installer": "Kelvin",
    "CustomerName": "Kevin Lidgard",
    "CustomerPhone": "0275 469 921",
    "GBContact": "Universal Dean",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Universal Dean",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/05/2017",
    "Address": "15 Floyd Rd Riverhead",
    "Issue": "carpet lifting",
    "Installer": "",
    "CustomerName": "Keryn Algie",
    "CustomerPhone": 21552582,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "29/04/2017",
    "Address": "15 Floyd Rd Riverhead",
    "Issue": "carpet lifting",
    "Installer": "",
    "CustomerName": "Keryn Algie",
    "CustomerPhone": "021 552 582",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/11/2017",
    "Address": "5 Steamer Rd Silverdale",
    "Issue": "bubble in floor under planks",
    "Installer": "Cole",
    "CustomerName": "Kerry Edmondson",
    "CustomerPhone": "027 244 4391",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Dave",
    "Notes": "Dave completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/06/2017",
    "Address": "9 Touhou Rd Hobsonville",
    "Issue": "lift carpet for floor remedial& return to refit",
    "Installer": "",
    "CustomerName": "Kennedy",
    "CustomerPhone": "021 588 591 Rhys",
    "GBContact": "Rhys Baker Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Rhys Baker Universal",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/10/2017",
    "Address": "9 Touhou Rd Hobsonville",
    "Issue": "replace front bedroom robe",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Kennedy",
    "CustomerPhone": 21786468,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "13/12/2016",
    "Address": "8 Deverell Pl Northcross",
    "Issue": "restretch 3 bedrooms (Jared laid)",
    "Installer": "Jared",
    "CustomerName": "Kelly Wills",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/01/2018",
    "Address": "117 Matua Rd Huapai",
    "Issue": "replace smoothedge and refit carpet",
    "Installer": "Ross",
    "CustomerName": "Kelly",
    "CustomerPhone": 21595685,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "7/03/2018",
    "Address": "3 Te Makuru Lane Maraetai",
    "Issue": "carpet lifting at ranchslider (concrete breaking away)",
    "Installer": "Ross",
    "CustomerName": "Kaye Baldwin",
    "CustomerPhone": 212860944,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/11/2016",
    "Address": "29 Captain Mitchell Dr Papakura",
    "Issue": "refit carpet around ranchsliders",
    "Installer": "Ross",
    "CustomerName": "Kate Ryder",
    "CustomerPhone": "027 889 5498",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "kate@bhwl.co.nz",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "21/11/2017",
    "Address": "51 Mapou Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Karen",
    "CustomerPhone": 21622004,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": 101505,
    "Received": "20/05/2016",
    "Address": "15 Kohia Way, Huapai",
    "Issue": "High traffic areas waring badly",
    "Installer": "",
    "CustomerName": "Karen",
    "CustomerPhone": "",
    "GBContact": "Brett Lennon",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett Lennon",
    "Status": "Assess 27.05.16",
    "Notes": "Normal track and shade listed by Grant T. Believes more foot traffic will flatten carpet and joins",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/03/2016",
    "Address": "18 Tuatua Rd Hobsonville",
    "Issue": "carpet lifting at tiles and lump in underlay",
    "Installer": "",
    "CustomerName": "Kadriye Kaya",
    "CustomerPhone": "027 777 6694",
    "GBContact": "Paul Westwood",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "paulwe@universal.co.nz",
    "GBStart": "Paul Westwood",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/02/2018",
    "Address": "47 Mapou Rd Hobsonville",
    "Issue": "carpet lifting at ranchslider and stairs",
    "Installer": "Ross",
    "CustomerName": "Justin",
    "CustomerPhone": "021 478 113",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "21/04/2017",
    "Address": "Judy Howe",
    "Issue": "restretch",
    "Installer": "Ross",
    "CustomerName": "Judy",
    "CustomerPhone": 4799773,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "3/11/2017",
    "Address": "18c Torrington Cres Glen Innes",
    "Issue": "bubble in floor under vanity",
    "Installer": "Kane",
    "CustomerName": "Josh",
    "CustomerPhone": 2102203214,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Kane",
    "Notes": "Kane completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "29/11/2017",
    "Address": "22 Merfield St GI",
    "Issue": "refit carpet where lifted for repairs",
    "Installer": "Ross",
    "CustomerName": "Josh",
    "CustomerPhone": "027 463 5038",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/02/2016",
    "Address": "1 malbec Pl Huapai",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Joseph",
    "CustomerPhone": 21454702,
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/03/2016",
    "Address": "28 Tilden Ave Hillcrest (FX client)",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Jonathan Whittaker",
    "CustomerPhone": "0211 475591",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/07/2017",
    "Address": "157 Hobsonville Pt Rd",
    "Issue": "Restretch stairs",
    "Installer": "",
    "CustomerName": "Jonathan",
    "CustomerPhone": 220372787,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/06/2016",
    "Address": "11 Woodridge Drive, Stanmore Bay",
    "Issue": "New smooth edge required due to leak",
    "Installer": "Someone from GJ completed",
    "CustomerName": "John Pearce",
    "CustomerPhone": "021 256 5416",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Phoned John",
    "Notes": "Needs builder to attend to skirting first. Samantha in contact",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 23202,
    "Received": "6/05/2016",
    "Address": "984 Paerata Road",
    "Issue": "Carpet in front of ranch slider not fixed down properly",
    "Installer": "Darryll",
    "CustomerName": "John Oliver",
    "CustomerPhone": "027 730 9292",
    "GBContact": "Meredith Gilmour",
    "GB": "",
    "CustomerEmail": "john@mcdni.co.nz",
    "GBStart": "Meredith Gilmour",
    "Status": "9/05/2016",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/08/2016",
    "Address": "32 Liquidambar Dr Hobsonville",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "John Lee",
    "CustomerPhone": 2040896257,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/11/2016",
    "Address": "32 Liquidambar Dr Hobsonville",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "John Lee",
    "CustomerPhone": 2040896257,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/01/2017",
    "Address": "33 Headland Dr Long Bay",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "John & Pia Wellingham",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/07/2017",
    "Address": "21 Onekiritea Rd Hobsonville",
    "Issue": "Re stretch all stairs",
    "Installer": "Andrew & Richard",
    "CustomerName": "Joel Bayangos",
    "CustomerPhone": "021 0266 4443",
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Andrew",
    "Notes": "Andrew completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/02/2016",
    "Address": "26D Moses Rd Kaukapakapa",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Jodie",
    "CustomerPhone": "09420 4244",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/08/2017",
    "Address": "34 Tuatua Rd Hobsonville",
    "Issue": "refit carpet 7 knock down pins",
    "Installer": "",
    "CustomerName": "Jin Moon",
    "CustomerPhone": "027 973 6969",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/08/2017",
    "Address": "3B Hobbs Rd Whangaparaoa",
    "Issue": "lump under vinyl",
    "Installer": "Dave",
    "CustomerName": "Jim & Kathy Stevens",
    "CustomerPhone": 212704720,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Dave",
    "Notes": "Dave  completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/04/2018",
    "Address": "LOT 3B HOBBS RD, WHANGAPARAOA",
    "Issue": "CARPET EDGE",
    "Installer": "ROSS",
    "CustomerName": "JIM",
    "CustomerPhone": "021-270 4720",
    "GBContact": "GJG RODNEY",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "GJG RODNEY",
    "Status": "Fixed by Ross",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/03/2018",
    "Address": "125 Hobsonville Pt Rd",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Jia",
    "CustomerPhone": "021 035 3678",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/02/2016",
    "Address": "31 Onekiritea Rd Hobsonville",
    "Issue": "Re stretch all stairs",
    "Installer": "Ross",
    "CustomerName": "Jeremy Duffin",
    "CustomerPhone": "021 129 5050",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/08/2016",
    "Address": "25 Paso Fino Cres Kingseat",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "Jenny Lee",
    "CustomerPhone": 2102401457,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "mitchelljennylee@gmail.com",
    "GBStart": "Meridith Gilmour",
    "Status": "ross doing 4/8/16",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/05/2017",
    "Address": "18 Huarahi Pai Rd GB327",
    "Issue": "Norm Hunt fixed all Lee cock ups",
    "Installer": "Lee",
    "CustomerName": "Jenny",
    "CustomerPhone": "021 042 7159",
    "GBContact": "Kara",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara",
    "Status": "Fixed by Norm Hunt",
    "Notes": "Norn completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/03/2016",
    "Address": "21 Aporo Dr Huapai",
    "Issue": "Carpet lifting in 2 corners",
    "Installer": "Ross",
    "CustomerName": "Jennifer McKay",
    "CustomerPhone": 2102637085,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/03/2016",
    "Address": "164 Hobsonville Pt Rd",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Jeff Paul",
    "CustomerPhone": "021 507 270",
    "GBContact": "Damon Hoskins Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Damon Hoskins Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/07/2017",
    "Address": "164 Hobsonville Pt Rd",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Jeff",
    "CustomerPhone": "021 507 270",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/03/2016",
    "Address": "35 Saltmarsh Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Jay",
    "CustomerPhone": 2102599559,
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101593,
    "Received": "10/05/2016",
    "Address": "12 Belvedere Place, Warkworth",
    "Issue": "Carpet lifting around kitchen tiles, master bedroom, garage door and front counter. Carpet in WIR does not meet skirting. Hard lump in underlay",
    "Installer": "George",
    "CustomerName": "Jason",
    "CustomerPhone": "0274 88 4610",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 18/05/2016",
    "Notes": "Glue woven into backing, with Grant T now.",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/03/2016",
    "Address": "25 Cape Cod Dr Gulf Harbour",
    "Issue": "carpet needs restretch all overBrett Amos",
    "Installer": "Brett Amos",
    "CustomerName": "Janine Wells",
    "CustomerPhone": 274305189,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "Universal",
    "GBStart": "Ian Donachie",
    "Status": "To be done ross/john",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/03/2016",
    "Address": "25 Cape Cod Dr Gulf Harbour",
    "Issue": "Re-Stretch with Johnny",
    "Installer": "Brett Amos",
    "CustomerName": "Janine Wells",
    "CustomerPhone": "0274 305 189",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/04/2017",
    "Address": "86 Squadron Dr Hobsonville",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "janie patroni",
    "CustomerPhone": "",
    "GBContact": "Damon Hoskins Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Damon Hoskins Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/03/2016",
    "Address": "37 Discovery Dr Gulf Harbour",
    "Issue": "carpet lifting & delaminating",
    "Installer": "Gabe",
    "CustomerName": "Jamie Clutterbuck",
    "CustomerPhone": "021 232 6784",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "To be repaired",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "25/11/2017",
    "Address": "53 Mapou Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Jae",
    "CustomerPhone": 210620705,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "3/03/2018",
    "Address": "2F Spotted Dove Rd Hobsonville",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Jacky",
    "CustomerPhone": 211112281,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "2/09/2017",
    "Address": "2 Spotted Dove Rd Hobsonville",
    "Issue": "trim carpet",
    "Installer": "Ross",
    "CustomerName": "Jackie Boyd",
    "CustomerPhone": 211112281,
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2018",
    "Address": "24 Makatiti St Puke",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Iona Cussen",
    "CustomerPhone": 2102718217,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "24/03/2016",
    "Address": "196 Hobsonville Pt Rd",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Ian Tay",
    "CustomerPhone": "021 041 7766",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/10/2016",
    "Address": "7 Laly Haddon Place, Matakana",
    "Issue": "Refit to wall and tile",
    "Installer": "Ross",
    "CustomerName": "Ian Tarpey",
    "CustomerPhone": "027 715 9359",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/10/2016",
    "Address": "49 Westmuir Cres Pokeno",
    "Issue": "Fraying edges by 3 ranch sliders",
    "Installer": "Darryl",
    "CustomerName": "Ian Brearley",
    "CustomerPhone": "027 488 2138",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Darryl",
    "Notes": "Darryl completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E9419",
    "Received": "20/06/2016",
    "Address": "7 Laly Haddon Place, Matakana",
    "Issue": "Carpet is pulling away from smooth edge",
    "Installer": "",
    "CustomerName": "Ian and Sally",
    "CustomerPhone": "021 184 6850",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 7/7/16 10:30am",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/03/2018",
    "Address": "48 Onekiritea Rd Hobsonville",
    "Issue": "fix stairs",
    "Installer": "Ross",
    "CustomerName": "Iain",
    "CustomerPhone": "02188 6863",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/03/2016",
    "Address": "45 Barcliff Tce Gulf Harbour",
    "Issue": "3 stairs re-stretch",
    "Installer": "Ross",
    "CustomerName": "Hennie",
    "CustomerPhone": 21827622,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "Universal",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/07/2016",
    "Address": "10 Gulf Crest, Bucklands Beach",
    "Issue": "Kick carpet onto smoothedge at ensuite door",
    "Installer": "Ross",
    "CustomerName": "Helen Tan",
    "CustomerPhone": "0274 428 638",
    "GBContact": "GJ Angela Munro",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "GJ Angela Munro",
    "Status": "Completed",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/05/2017",
    "Address": "18B Martindale Lane Tuakau",
    "Issue": "carpet lifting in several areas",
    "Installer": "Andrew Walker",
    "CustomerName": "Hayley Thompson",
    "CustomerPhone": 21702872,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "hayleyt@nzinvest.co.nz",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/03/2016",
    "Address": "5 Kuawa Dr Huapai",
    "Issue": "replace s/e and refit water damage",
    "Installer": "Ross",
    "CustomerName": "Hayley Arnold",
    "CustomerPhone": 2102603577,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "9/04/2018",
    "Address": "7 Chaffinch Rd Hobsonville",
    "Issue": "need to improve join",
    "Installer": "Grant",
    "CustomerName": "Hannah Kelly",
    "CustomerPhone": "021 0269 4420",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/02/2018",
    "Address": "1 Andrew Jack Rd Silverdale",
    "Issue": "Carpet loose",
    "Installer": "Ross",
    "CustomerName": "Hannah",
    "CustomerPhone": "021 261 7684",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/06/2017",
    "Address": "20 Tuatua Rd Hobsonville",
    "Issue": "carpet lifting in ares & restretch stairs",
    "Installer": "",
    "CustomerName": "Gregory",
    "CustomerPhone": "021 2448921  Gregory",
    "GBContact": "Morne Botha Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "greg.vaughan@edlfast.co.nz",
    "GBStart": "Morne Botha Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/03/2018",
    "Address": "1 Copestake Lane Warkworth",
    "Issue": "trim sprouted carpet",
    "Installer": "Ross",
    "CustomerName": "Greg Powell",
    "CustomerPhone": "027 470 1028",
    "GBContact": "Ricky Sampson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Ricky Sampson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/10/2016",
    "Address": "26 Pioneer Rise Millwater",
    "Issue": "carpet lifting on landings",
    "Installer": "Ross",
    "CustomerName": "Greg & Rachel Brand",
    "CustomerPhone": "021 191 2621  Greg",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/04/2018",
    "Address": "LOT 18, 26 PIONEER RISE, MILLWATER",
    "Issue": "FIX CARPET BACK DOWN - CHARGED",
    "Installer": "ROSS",
    "CustomerName": "GREG",
    "CustomerPhone": "021-191 2621",
    "GBContact": "GJG RODNEY",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "GJG RODNEY",
    "Status": "Fixed by Ross",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E9264",
    "Received": "3/06/2016",
    "Address": "15A Inglewood Street, Wai O Taki Bay",
    "Issue": "Carpet pulling off stairs",
    "Installer": "Kelvin",
    "CustomerName": "Graham",
    "CustomerPhone": "021 847 939",
    "GBContact": "Angela Munro",
    "GB": "",
    "CustomerEmail": "graham.kock@gmail.com",
    "GBStart": "Angela Munro",
    "Status": "TBF 29/6/16 930am",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/03/2016",
    "Address": "64 Harris Dr Millwater",
    "Issue": "carpet lifting at tiles",
    "Installer": "AK Flooring",
    "CustomerName": "Graeme Sorenson",
    "CustomerPhone": 274987865,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/05/2017",
    "Address": "28 Portland Park Millwater",
    "Issue": "carpet lifting",
    "Installer": "",
    "CustomerName": "Graeme Osborne",
    "CustomerPhone": "027 245 8822",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "graemarj@xtra.co.nz",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/03/2016",
    "Address": "13 Oak Valley Rd Dairy Flat",
    "Issue": "Replace carpet in main bedroom",
    "Installer": "Matt",
    "CustomerName": "Glen McLeod",
    "CustomerPhone": 21835574,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/05/2017",
    "Address": "9 Barcliff Tce Gulf Harbour",
    "Issue": "Remove object under carpet in LG/Dining",
    "Installer": "",
    "CustomerName": "Glen Jujinovich",
    "CustomerPhone": 272853668,
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 66,
    "Received": "28/05/2018",
    "Address": "LOT 35, 111 KAREPIRO DRIVE, STANMORE BAY",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "CARPET LIFTING IN SMALL AREA ROSS 12.00PM 29/05/2018",
    "CustomerName": "GJG RODNEY",
    "CustomerPhone": "",
    "GBContact": "021 0239 3010",
    "GB": "",
    "CustomerEmail": "SUREKHA",
    "GBStart": "021 0239 3010",
    "Status": "",
    "Notes": "SAM HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 86,
    "Received": "25/06/2018",
    "Address": "11 KAURI HEART AVE, ADDISON",
    "Issue": "South",
    "Installer": "CARPET IN HALL LIFTING/NAILS ETC - ANDREW TO DO THIS WHEN INSTALLING GARAGE CARPET",
    "CustomerName": "GJG PAPAKURA",
    "CustomerPhone": "ANDREWS CARPETS",
    "GBContact": "021-990 867",
    "GB": "",
    "CustomerEmail": "BRIAR",
    "GBStart": "021-990 867",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 77,
    "Received": "5/06/2018",
    "Address": "15 KAPIA ST, BELMONT GB2028",
    "Issue": "South",
    "Installer": "INJOON WATER LEAK  INJOON BOOKED 21/07/2018 ROSS HAS FOLDER PO 060787 - TO CHARGE",
    "CustomerName": "GJG PAPAKURA",
    "CustomerPhone": "INJOON",
    "GBContact": "021-918 579",
    "GB": "",
    "CustomerEmail": "CHARL",
    "GBStart": "021-918 579",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 61,
    "Received": "16/05/2018",
    "Address": "HNZ HAPAI PRESIDENT BELGRAVE AND WIKI",
    "Issue": "SOUTH",
    "Installer": "3 HAPAI 32-34 PRESIDENT DOING 20/06/2018 BOOKED 9.30-2.00PM",
    "CustomerName": "GJG PAPAKURA",
    "CustomerPhone": "WAGE BOYS",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 30,
    "Received": "17/04/2018",
    "Address": "LOT 8, 90 MOUNT ALBION RISE, TAUPAKI",
    "Issue": "Rodney",
    "Installer": "CARPET LIFTING IN NUMEROUS - ROSS FIXING FRI 11/05/2018 3.30PM",
    "CustomerName": "GJ Rodney West",
    "CustomerPhone": "",
    "GBContact": "020-420 2122",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "DALLAS",
    "GBStart": "020-420 2122",
    "Status": "",
    "Notes": "GJG WEST",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/05/2016",
    "Address": "6 Aporo Dr Huapai",
    "Issue": "fit own carpet to robe",
    "Installer": "Johnny Nicholson",
    "CustomerName": "GJ Rodney West",
    "CustomerPhone": 94125371,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Johnny",
    "Notes": "To be done 31st May Johnny",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/06/2017",
    "Address": "3 Flavell Dr Millwater",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "GJ Rodney East",
    "CustomerPhone": "427 9231",
    "GBContact": "Ross Murray",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 45,
    "Received": "26/04/2018",
    "Address": "9 PAPA ORCHARD, HUAPAI",
    "Issue": "Rodney",
    "Installer": "CRACKLING UNDER CARPET - WAYNE WED 16/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "RODNEY RESIDENTIAL LTD",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "SARAH FOLEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 72,
    "Received": "7/06/2018",
    "Address": "LOT 1, 64 KAIPARA COAST H/W, HELENSVILLE",
    "Issue": "Rodney",
    "Installer": "DAMAGE TO WALLS - GJG TO INVOICE FLOORING JUNCTION FOR REPAIRS - FILE CLOSED",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "RODNEY RESIDENTIAL LTD",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 73,
    "Received": "7/06/2018",
    "Address": "23 HENLEY ROAD, KAUKAPAKAPA",
    "Issue": "Rodney",
    "Installer": "BUILDER UPLIFTED CARPET - FLOORING JUNCTION REINSTATED CARPET AS BEST AS POSSIBLE - FILE CLOSED",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "RODNEY RESIDENTIAL LTD",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "SAM HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 76,
    "Received": "13/06/2018",
    "Address": "LOTS 59, 60, 61 KAREPIRO DRIVE",
    "Issue": "Rodney",
    "Installer": "ROSS INSPECTING 13/06/2018 2.00PM",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "RODNEY RESIDENTIAL LTD",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 90,
    "Received": "2/07/2018",
    "Address": "15 JOHN ANDREW DRIVE, WARKWORTH",
    "Issue": "North",
    "Installer": "CARPET IN BEDROOM LIFTING - ROSS INSPECTING/FIXING 02/07/2018 OUT OF WARRANTY-SAM ADVISED",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "JOHN NICHOLSON",
    "GBContact": "09-422 2241",
    "GB": "",
    "CustomerEmail": "MIKE OR SUZANNE",
    "GBStart": "09-422 2241",
    "Status": "",
    "Notes": "SAMANTHA HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 20,
    "Received": "17/04/2018",
    "Address": "LOT 1, 16 LAGOON VIEW HOBBS BAY",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "CARPET NOT SITTING FLAT -  DAVE BOOKED TUES 19/06/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "027-405 2989",
    "GB": "",
    "CustomerEmail": "ADAM",
    "GBStart": "027-405 2989",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/04/2018",
    "Address": "LOT 242, 16 WHALEY GREENS, MILLWATER",
    "Issue": "Rodney",
    "Installer": "VINYL / CARPET NEEDS TO BE FIXED  -  ROSS BOOKED 08/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "027-305 1817",
    "GB": "",
    "CustomerEmail": "GRANT",
    "GBStart": "027-305 1817",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 21,
    "Received": "17/04/2018",
    "Address": "LOT 1, 64 KAIPARA COAST H/W",
    "Issue": "Rodney",
    "Installer": "CARPET LOOKING OLD FOR WEAR Replacement arrived, - BOOKED FOR 09/05/2018 - DONE / CHARGED YES",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "027-283 3295",
    "GB": "",
    "CustomerEmail": "BRONWYN",
    "GBStart": "027-283 3295",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 10,
    "Received": "17/04/2018",
    "Address": "LOT 320, 11 FERMIER GREENS, MILLWATER",
    "Issue": "Rodney",
    "Installer": "GB0849 - REPAIR PLANKS - DAVE HAS PRODUCT - DONE!!@ 7.30 THURSDAY 24/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-806 083",
    "GB": "",
    "CustomerEmail": "STEVE",
    "GBStart": "021-806 083",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "18/4/2018 Ross inspected, need 1 box",
    "Chargeable": ""
  },
  {
    "JobNumber": 62,
    "Received": "21/05/2018",
    "Address": "LOT 3, 25 HOBBS ROAD, MATAKATIA BAY",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "ROSS BOOKED 28/05/2018 MORNING CARPET REPAIR AS THE SMOOTH EDGE HAS COME AWAY FROM THE CONCRETE KITCHEN/FAMILY ROOM",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-530 166",
    "GB": "",
    "CustomerEmail": "KAREN BROOKE",
    "GBStart": "021-530 166",
    "Status": "",
    "Notes": "SAM HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 56,
    "Received": "7/05/2018",
    "Address": "LOT 9, 18 RESOLUTION DRIVE, WHANGA",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "NO WARRANTY FOR FADING - DAVE TO TIDY UP GAPS - 31/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-517 843",
    "GB": "",
    "CustomerEmail": "JACK AND LOUISE",
    "GBStart": "021-517 843",
    "Status": "",
    "Notes": "SAM HYLAND",
    "Advised": "",
    "Billed": "11/5/18 Inspected, send complaint",
    "Chargeable": ""
  },
  {
    "JobNumber": 24,
    "Received": "17/04/2018",
    "Address": "LOT 96, 39 AURORA AVE, SNELLS BEACH",
    "Issue": "North",
    "Installer": "50/50 CHARGE OUT ON INSTALL - 2ND FAULT - CASH OFFER PAID -  deliver garage carpet in settlement",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-488 455",
    "GB": "",
    "CustomerEmail": "LYNNE",
    "GBStart": "021-488 455",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 17,
    "Received": "17/04/2018",
    "Address": "LOT 6, 12 RESOLUTION DRIVE, GULF HAR",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "VINYL FLOORING MESSY WITH GLUE AND JOINS - ROSS  SIGHTED 08/05/2018 - DAVE- COMPLETED",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-457 029",
    "GB": "",
    "CustomerEmail": "KIRSTY",
    "GBStart": "021-457 029",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 28,
    "Received": "17/04/2018",
    "Address": "LOT 3, 3B HOBBS RD, WHANGAPARAOA",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "VINYL LIFTING  DAVE COMPLETED 15/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-270 4720`",
    "GB": "",
    "CustomerEmail": "JIM",
    "GBStart": "021-270 4720`",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 79,
    "Received": "13/06/2018",
    "Address": "LOT 54, 37 DISCOVERY DRIVE, GH  -   E0127",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "CRACK IN CONCRETE - DAVE - GO AHEAD FIX NO MATTER WHAT 'SAM' PO 19471 ROSS HAS FOLDER",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-232 6784",
    "GB": "",
    "CustomerEmail": "JAMIE",
    "GBStart": "021-232 6784",
    "Status": "",
    "Notes": "SAMANTHA HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 1,
    "Received": "17/04/2018",
    "Address": "LOT 20, 23 TUATUA ROAD, HOBSONVILLE",
    "Issue": "Rodney",
    "Installer": "LOUNGE CARPET DIFFERENT COLOUR REPLACING CARPET - ROSS INSTALLING 12/05/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "GRANT",
    "GBContact": "021-216 8086",
    "GB": "",
    "CustomerEmail": "COURTNEY",
    "GBStart": "021-216 8086",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101,
    "Received": "7/08/2018",
    "Address": "26 PIONEER RISE, MILLWATER",
    "Issue": "Rodney",
    "Installer": "CARPET FRAYING AT ENTRANCE TO ENSUITE- ROSS BOOKED THURSDAY 9.00AM 09/08/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "DARRYLL",
    "GBContact": "021-191 2621",
    "GB": "",
    "CustomerEmail": "GREG",
    "GBStart": "021-191 2621",
    "Status": "",
    "Notes": "SAMANTHA",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 26,
    "Received": "17/05/2018",
    "Address": "88 SOLAN DRIVE, WAIMAUKU",
    "Issue": "Rodney",
    "Installer": "DISCOLOURATION AROUND JOINS VINYL  -  DAVE COMPLETED THURSDAY 17/05/2018 ADVISED SARAH",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "DAVE WALKER",
    "GBContact": "021-121 9880",
    "GB": "",
    "CustomerEmail": "DEEP",
    "GBStart": "021-121 9880",
    "Status": "",
    "Notes": "SARAH FOLEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 19,
    "Received": "17/04/2018",
    "Address": "L0T 22,4 GRAPNEL ST PARKWAY ESTATE",
    "Issue": "Rodney",
    "Installer": "DISHWASHER LEAK REPAIR  - DAVE TO FIX AND CHARGE DIRECT",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "? CHARGE DIRECT",
    "GBContact": "021-112 0055",
    "GB": "",
    "CustomerEmail": "HENRY (BROTHER)",
    "GBStart": "021-112 0055",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "need to order plank &repair",
    "Chargeable": ""
  },
  {
    "JobNumber": 93,
    "Received": "9/07/2018",
    "Address": "LOT 81, 13 MOTITI ST, WARKWORTH",
    "Issue": "NORTH",
    "Installer": "SOMETHING UNDER CARPET SPARE ROOM - MATT BOOKED FRI 20/07/2018 9.30AM",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "ROMMEL",
    "GBContact": "021-051 0529",
    "GB": "",
    "CustomerEmail": "EMMA",
    "GBStart": "021-051 0529",
    "Status": "",
    "Notes": "SAMANTHA HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 12,
    "Received": "17/04/2018",
    "Address": "LOT 103, 6 TIROHANGA CRES, STANMORE",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "DAVE DONE!!!!! - BRING OLD PLANKS BACK!!  TO INVOICE POLYFLOR",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-0263 3247",
    "GB": "",
    "CustomerEmail": "CORINNE",
    "GBStart": "021-0263 3247",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 80,
    "Received": "13/06/2018",
    "Address": "LOT 103, 6 TIROHANGA CRES, STANMORE BAY",
    "Issue": "Whangaparaoa Peninsula",
    "Installer": "CARPET COMING 'UNDONE' -  DAVE BOOKED TUES 19/06/2018",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-0263 3247",
    "GB": "",
    "CustomerEmail": "CORINNE",
    "GBStart": "021-0263 3247",
    "Status": "",
    "Notes": "SAMANTHA HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 9,
    "Received": "17/04/2018",
    "Address": "LOT 109, 18 ARRIERE LANE, MILLWATER",
    "Issue": "Rodney",
    "Installer": "JOINS - RYAN GJG TO CONTACT US - COLIN - FILE IS NOW CLOSED",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021-0227 7206",
    "GB": "",
    "CustomerEmail": "MELINDA",
    "GBStart": "021-0227 7206",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 81,
    "Received": "14/06/2018",
    "Address": "Lot 6, 3 CHAFFINCH RD",
    "Issue": "Rodney",
    "Installer": "LAY CARPET IN ENTRY CUPBOARD 14/6/18 Ross inspected, need carpet for cupboard(charge)",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "",
    "GBContact": "021 750 474",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "021 750 474",
    "Status": "",
    "Notes": "DEAN HODGSON",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 99,
    "Received": "31/07/2018",
    "Address": "LOT 97, 41 AUROA AVE, SNELLS BEACH",
    "Issue": "North",
    "Installer": "CARPET INPERFECTIONS - JOINS KELVIN BOOKED MON 06/08/2018 - BLUE KEY",
    "CustomerName": "GJ RODNEY",
    "CustomerPhone": "KELVIN",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "RICKY SAMPSON",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 47,
    "Received": "26/04/2018",
    "Address": "9 TAWAKI AVE, ADDISON PARK",
    "Issue": "South",
    "Installer": "RESULT - NEEDS POWER STRETCH!! TAINUI MEETING WITH KEITH MONDAY 30/07/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "",
    "GBContact": "298 7977 BARFOOT",
    "GB": "",
    "CustomerEmail": "PEGGY FELL",
    "GBStart": "298 7977 BARFOOT",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 110,
    "Received": "31/08/2018",
    "Address": "13 CAPTAIN MITCHELL DRIVE, PAPAKURA",
    "Issue": "SOUTH",
    "Installer": "CARPET LIFTING BETWEEN KITCHEN TILES AND LOUNGE ROSS 04/09/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "KELVIN/DARRYLL",
    "GBContact": "022-324 9714",
    "GB": "",
    "CustomerEmail": "TIMOTHY",
    "GBStart": "022-324 9714",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 85,
    "Received": "20/06/2018",
    "Address": "3B HILLPARK DRIVE POKENO",
    "Issue": "South",
    "Installer": "RESTRETCH CARPET BACK ON TO SMOOTHEDGE- ROSS DOING FRIDAY 22/06/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "",
    "GBContact": "022 163 0270",
    "GB": "",
    "CustomerEmail": "KIMBERLEY",
    "GBStart": "022 163 0270",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 106,
    "Received": "28/08/2018",
    "Address": "LOT 19 FENCHURCH, GLEN INNES",
    "Issue": "SOUTH",
    "Installer": "NAILS FELT THROUGHT CARPET ON STAIRS- ROSS/MINESH 2.30PM 04/09/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "FLOORBIZ",
    "GBContact": "021-990 162",
    "GB": "",
    "CustomerEmail": "MINESH",
    "GBStart": "021-990 162",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 84,
    "Received": "19/06/2018",
    "Address": "18 HELENVALE CRESCENT, POKENO",
    "Issue": "South",
    "Installer": "CARPET PULLING UP FROM UNDER TRIM - ANDREW DOING FRIDAY 22/06/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "ANDREWS CARPETS",
    "GBContact": "021-978 798",
    "GB": "",
    "CustomerEmail": "STEFANIE",
    "GBStart": "021-978 798",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 46,
    "Received": "26/04/2018",
    "Address": "ESK ROAD, MIRANDA",
    "Issue": "South",
    "Installer": "RESTRETCH - DID KELVIN DO THIS 05/05/2018?????????",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "",
    "GBContact": "021-522 333",
    "GB": "",
    "CustomerEmail": "MAREE",
    "GBStart": "021-522 333",
    "Status": "",
    "Notes": "MERIDITH",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 100,
    "Received": "1/08/2018",
    "Address": "35 MCNALLY ROAD, PUKEKOHE",
    "Issue": "South",
    "Installer": "CARPET LIFTING FROM ENTRANCE TO ENSUITE - KELVIN BOOKED THUR 02/08/2018 'AM'",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "KELVIN",
    "GBContact": "021-068 7532",
    "GB": "",
    "CustomerEmail": "JACQUE SIMMONS",
    "GBStart": "021-068 7532",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 78,
    "Received": "24/05/2018",
    "Address": "29 SEARLE DR PATUMAHOE",
    "Issue": "South",
    "Installer": "REFIT CARPET AT TILES 13/06/2018 TODD RANG - ROSS Doing Friday June 15th",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "",
    "GBContact": "021 783 082",
    "GB": "",
    "CustomerEmail": "TODD",
    "GBStart": "021 783 082",
    "Status": "",
    "Notes": "AMANDA REID",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 97,
    "Received": "23/07/2018",
    "Address": "70A HILLPARK DRIVE POKENO",
    "Issue": "South",
    "Installer": "ROSS CONTACTED TENANT. BOOKED FRIDAY 27/07/2018",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "DARRYL CHURCH",
    "GBContact": "021 277 6227",
    "GB": "",
    "CustomerEmail": "SHANNON",
    "GBStart": "021 277 6227",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/05/2018",
    "Address": "18 CANINI GROVE KARAKA",
    "Issue": "SOUTH",
    "Installer": "CARPET FRAYING ROUND TILES",
    "CustomerName": "GJ PAPAKURA",
    "CustomerPhone": "",
    "GBContact": 92984645,
    "GB": "",
    "CustomerEmail": "JAN",
    "GBStart": 92984645,
    "Status": "",
    "Notes": "AMANDA",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/01/2018",
    "Address": "GJ Showhome Millwater",
    "Issue": "vinyl lifting",
    "Installer": "",
    "CustomerName": "GJ Gardner",
    "CustomerPhone": 94279231,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "10/03/2018",
    "Address": "57 Colonial Dr Silverdale",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "George",
    "CustomerPhone": "027 279 9415",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "15/10/2016",
    "Address": "761 Woodcocks Rd warkworth",
    "Issue": "Vinyl planking  re glue",
    "Installer": "Cole",
    "CustomerName": "Gaye Ward",
    "CustomerPhone": "0274 838 949",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Dave",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101564,
    "Received": "9/05/2016",
    "Address": "16 Pioneer Rise, Millwater",
    "Issue": "Vinyl sticking up in front of slider",
    "Installer": "Mark",
    "CustomerName": "Gary",
    "CustomerPhone": "021 244 6561",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 8th 430pm",
    "Notes": "Had photos through and Mark looking to attend week of 7th June",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/06/2016",
    "Address": "24 Riverhead Point Drive",
    "Issue": "2 lines across the carpet",
    "Installer": "",
    "CustomerName": "Gary",
    "CustomerPhone": "027 801 3241",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "gary.grenfell@swirecnco.com",
    "GBStart": "Ross Murray",
    "Status": "Inspection sent",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "27/09/2017",
    "Address": "56 Helenslee Rd Pokeno",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Garpell",
    "CustomerPhone": 220432951,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": 92,
    "Received": "3/07/2018",
    "Address": "LOT 13, 23 TE MAKURU LANE, MARAETAI",
    "Issue": "SOUTH",
    "Installer": "CARPET COMING AWAY FROM SMOOTHEDGE - BOOKED ROSS 06/07/2018 CLIENT HOME ALL DAY",
    "CustomerName": "G J MANUKAU",
    "CustomerPhone": "ANDREWS CARPETS",
    "GBContact": "021-0243 6226",
    "GB": "",
    "CustomerEmail": "IRINA",
    "GBStart": "021-0243 6226",
    "Status": "",
    "Notes": "MAVIS",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/02/2016",
    "Address": "12 Eric Farley Dr Huapai",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Fiona Murray 027 261 1939",
    "CustomerPhone": "",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/06/2017",
    "Address": "12 Eric Farley Dr Huapai",
    "Issue": "attend to crackle in floor",
    "Installer": "",
    "CustomerName": "Fiona Murray",
    "CustomerPhone": 272611939,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/11/2016",
    "Address": "1 Corsair St Hobsonville",
    "Issue": "repair carpet join opening up( De-Lamination)",
    "Installer": "Ross",
    "CustomerName": "Fiona (tenant)",
    "CustomerPhone": "021 107 9651",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "15/11/2017",
    "Address": "21 Meteor Rd Hobsonville",
    "Issue": "Stairs and fill hole",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Ferdinand",
    "CustomerPhone": 220218808,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Kelvin",
    "Notes": "Kelvin completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/11/2016",
    "Address": "64 Cape Cod Dr Gulf Harbour",
    "Issue": "Fix stair and fit underlay in step to entry",
    "Installer": "Ross",
    "CustomerName": "Fay Tikey",
    "CustomerPhone": 275477007,
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/02/2016",
    "Address": "367 Millwater Parkway Silverdale",
    "Issue": "refit flood damage from shower leak",
    "Installer": "Ross",
    "CustomerName": "Eve Taylor",
    "CustomerPhone": "021 407 200",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "16/06/2017",
    "Address": "14 Outlook Tce Millwater",
    "Issue": "Fix stairs etc",
    "Installer": "Matt Bunn",
    "CustomerName": "Eric Legasto",
    "CustomerPhone": "021 078 0384",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/08/2017",
    "Address": "3 Andrew Jack Rd Millwater",
    "Issue": "trim white thread out of carpet",
    "Installer": "Ross",
    "CustomerName": "Emma-Jane",
    "CustomerPhone": "021 176 3224",
    "GBContact": "Tony Bibbie",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Tony Bibbie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/07/2017",
    "Address": "31 Pamela Christine Rd Patumahoe",
    "Issue": "carpet lifting at ranchsliders, and check for excess wear",
    "Installer": "",
    "CustomerName": "Emma Klokie",
    "CustomerPhone": 211631893,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "emmaklokie@gmail.com",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "7/10/2016",
    "Address": "10 Harvard St Hobsonville",
    "Issue": "Restretch in hall,Lg and all stairs",
    "Installer": "Matt",
    "CustomerName": "Emma",
    "CustomerPhone": "550 3892",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Johnny",
    "Notes": "Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/10/2017",
    "Address": "54 Harbour Crest Drive Waiuku",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Elie",
    "CustomerPhone": 211488094,
    "GBContact": "Briar Irwin",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Briar Irwin",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101517,
    "Received": "29/03/2016",
    "Address": "Lot 185, 88 Tapu Road, Huapai",
    "Issue": "Garage transition strip required",
    "Installer": "",
    "CustomerName": "Ehsan and Shadi",
    "CustomerPhone": "021 0233 6281",
    "GBContact": "Brett Lennon",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett Lennon",
    "Status": "TBF 21/6/16 3:30",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/09/2017",
    "Address": "24 Colonial Dr Silverdale",
    "Issue": "Relay carpet to LG & Bedroom after builder",
    "Installer": "Ross",
    "CustomerName": "Echo",
    "CustomerPhone": 210322106,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "21/06/2017",
    "Address": "lot 3/6 Pioneer Rise Millwater",
    "Issue": "supply/fit new planking where wall moved",
    "Installer": "Dave",
    "CustomerName": "Dunlop",
    "CustomerPhone": "027 220 9515 Heather",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Dave",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "25/11/2016",
    "Address": "20A Grove Rd Papakura",
    "Issue": "re-stretch and split join",
    "Installer": "Ross",
    "CustomerName": "Doris Brading",
    "CustomerPhone": "92995954  021068 1010",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "2/06/2017",
    "Address": "9 Mapou Rd Hobsonville",
    "Issue": "carpet lifting in several areas + stairs",
    "Installer": "",
    "CustomerName": "Dmitri",
    "CustomerPhone": "021 746 963",
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/12/2016",
    "Address": "19 Tennessee Rd Mangere",
    "Issue": "hit down smoothedge",
    "Installer": "Ross",
    "CustomerName": "Desma",
    "CustomerPhone": 211185338,
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "6/09/2017",
    "Address": "22 Whaley Greens Millwater",
    "Issue": "refit lifting carpet",
    "Installer": "Ross",
    "CustomerName": "Dennis",
    "CustomerPhone": "021 132 0404",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "12/09/2017",
    "Address": "11 Spotted Dove Rd",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Denis Feoktistov",
    "CustomerPhone": 220398683,
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/08/2017",
    "Address": "200B Bawden Rd Albany",
    "Issue": "refit leak carpet",
    "Installer": "Ross",
    "CustomerName": "Debbie Glen",
    "CustomerPhone": "021 450 871",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/02/2016",
    "Address": "200B Bawden Rd Albany",
    "Issue": "refit flood damage",
    "Installer": "Ross",
    "CustomerName": "Debbie Glen",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "20/09/2016",
    "Address": "366 Riddell Rd Glendowie",
    "Issue": "rejoined join cut by builders",
    "Installer": "Matt",
    "CustomerName": "Dean Pointon",
    "CustomerPhone": "027 252 8720",
    "GBContact": "Christian",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Christian",
    "Status": "Fixed by Matt",
    "Notes": "Matt completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "N/A",
    "Received": "",
    "Address": "366A Riddell Road, Glendowie",
    "Issue": "Sucked up pieces of carpet, appears to be cut short. Builder had cut and rejoined carpet for access.",
    "Installer": "Darryll + Johnny",
    "CustomerName": "Dean",
    "CustomerPhone": "",
    "GBContact": "Christian Welham",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Christian Welham",
    "Status": "10/05/2016",
    "Notes": "Chargeable, builder ripped open carpet to mend floor",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "29/04/2017",
    "Address": "3 Micheala Lane Kaukapakapa",
    "Issue": "major floor levelling to entry tiles",
    "Installer": "Dave Walker",
    "CustomerName": "David Paul",
    "CustomerPhone": "021 675 137",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Dave",
    "Notes": "Dave completed May 1  2017",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/12/2017",
    "Address": "46 Boundary Rd Papakura",
    "Issue": "staple all tile transitions",
    "Installer": "Ross",
    "CustomerName": "David Barnett",
    "CustomerPhone": "021 061 0773",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101606,
    "Received": "30/05/2016",
    "Address": "53 Discovery Drive, Gulf Harbour",
    "Issue": "Vinyl planking raised in kitchen",
    "Installer": "",
    "CustomerName": "David",
    "CustomerPhone": "021 288 0303",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 10/06/2016 930am",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/09/2017",
    "Address": "12 Tua Tua Rd Hobsonville",
    "Issue": "Stretch and refit to kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "Darryl",
    "CustomerPhone": 211900379,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "26/09/2017",
    "Address": "6 Aro Mato, Matua",
    "Issue": "carpet lifting in several areas",
    "Installer": "Ross",
    "CustomerName": "Daniel",
    "CustomerPhone": 221766123,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/06/2017",
    "Address": "159 Hobsonville Pt Rd",
    "Issue": "repair floor relay carpet",
    "Installer": "",
    "CustomerName": "Daniel",
    "CustomerPhone": "021 430 154",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/09/2017",
    "Address": "22 Colonial Dr Silverdale",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Dan",
    "CustomerPhone": 274740007,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "10/05/2017",
    "Address": "3 Aro Mato, Matua",
    "Issue": "carpet lifting in several areas",
    "Installer": "",
    "CustomerName": "Dan",
    "CustomerPhone": 274033882,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/03/2018",
    "Address": "32 Screen Rd Coatesville",
    "Issue": "trim faults in carpet",
    "Installer": "Ross",
    "CustomerName": "Crow",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/04/2017",
    "Address": "1096A Awhitu Rd Waiuku",
    "Issue": "restretch",
    "Installer": "Ross",
    "CustomerName": "Craig Rollitt",
    "CustomerPhone": 211589475,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "crag71@gmail.com",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/11/2016",
    "Address": "50 Milano Boulevard Karaka",
    "Issue": "replace s/e and refit water damage",
    "Installer": "Ross",
    "CustomerName": "Colin Hussys",
    "CustomerPhone": 274961937,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "9/09/2016",
    "Address": "25 Westmuir Crescent Pokeno",
    "Issue": "Fixed all joins and carpet at transitions and tear in carpet",
    "Installer": "Ross",
    "CustomerName": "Clinton Ballot",
    "CustomerPhone": 212421696,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "clinton@cp-1.co.nz",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/11/2016",
    "Address": "25 Westmuir Crescent Pokeno",
    "Issue": "Fixed all joins and carpet at transitions and tear in carpet",
    "Installer": "Ross",
    "CustomerName": "Clinton Ballot",
    "CustomerPhone": 212421696,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "clinton@cp-1.co.nz",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 94,
    "Received": "9/07/2018",
    "Address": "92 TORARA VIEWS DRIVE, SILVERDALE",
    "Issue": "Rodney",
    "Installer": "SMOOTHEDGE LIFTING FROM CONCRETE - ROSS BOOKED THURSDAY 12/07/2018 3.30PM",
    "CustomerName": "CLIENT DIRECT GJ RODNEY",
    "CustomerPhone": "MATTHEW - 2013",
    "GBContact": "021-151 8708",
    "GB": "",
    "CustomerEmail": "MIKE",
    "GBStart": "021-151 8708",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/03/2016",
    "Address": "133 Hobsonville Pt Rd",
    "Issue": "Carpet loose on stairs",
    "Installer": "Ross",
    "CustomerName": "Clare Allen",
    "CustomerPhone": "027 617 9155",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/02/2018",
    "Address": "125 Matua Rd Huapai",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Claire Foley",
    "CustomerPhone": "027 357 1790",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/08/2016",
    "Address": "37 Headland Dr Long Bay",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "Claire Dowron",
    "CustomerPhone": "021 177 6326",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 22885,
    "Received": "6/05/2016",
    "Address": "16 Millbrae Place, Pokeno",
    "Issue": "Carpet coming away around kitchen and study nook",
    "Installer": "Kelvin",
    "CustomerName": "Claire",
    "CustomerPhone": "027 511 4856",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 14/05/2016",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/01/2017",
    "Address": "3 Modello Lane Waiuku",
    "Issue": "carpet lifting and small re-stretch",
    "Installer": "Ross",
    "CustomerName": "Christine Horscroft",
    "CustomerPhone": 21797510,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2018",
    "Address": "44 Bomb Pt Dr Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Christina",
    "CustomerPhone": 2102620381,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "18/04/2017",
    "Address": "15 Mataoho Rd Mangere",
    "Issue": "carpet lifting in places",
    "Installer": "Ross",
    "CustomerName": "Chris Gupta",
    "CustomerPhone": 210357493,
    "GBContact": "Mavis GJ",
    "GB": "OMAHA HOLDINGS LTD",
    "CustomerEmail": "",
    "GBStart": "Mavis GJ",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "8/11/2016",
    "Address": "lot 12 47 Yates Rd Mangere",
    "Issue": "Sprouting/Cropping issue",
    "Installer": "Ross",
    "CustomerName": "Chris Goyal",
    "CustomerPhone": 210357493,
    "GBContact": "Ryan Meynell",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Ryan Meynell",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "N/A",
    "Received": "19/04/2016",
    "Address": "122 Hobsonville Point Road",
    "Issue": "Wear through hallway and side rooms. NEC required",
    "Installer": "Richard & Andrew",
    "CustomerName": "Charlotte Glidden",
    "CustomerPhone": "412 9521",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "charlotte@bbp.co.nz",
    "GBStart": "",
    "Status": "pending",
    "Notes": "Colin and Carl visited 28/6/16 Advised for stress test.",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "8/09/2016",
    "Address": "122 Hobsonville Point Road",
    "Issue": "Fixed all rippling stairs",
    "Installer": "Ross",
    "CustomerName": "Charlotte Glidden",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "charlotte@bbp.co.nz",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/04/2017",
    "Address": "18 Tuatua Rd Hobsonville",
    "Issue": "lump under carpet in bedroom",
    "Installer": "Ross",
    "CustomerName": "Charlotte",
    "CustomerPhone": "027 777 6694",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "9/09/2017",
    "Address": "18 Tua Tua Rd Hobsonville",
    "Issue": "refit lifting carpet on stairs",
    "Installer": "Ross",
    "CustomerName": "Charlotte",
    "CustomerPhone": 277776694,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "4/04/2018",
    "Address": "13 Glory Way",
    "Issue": "carpet lifting at tiles & wall",
    "Installer": "Ross",
    "CustomerName": "Cezar",
    "CustomerPhone": 277890012,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "15/11/2016",
    "Address": "2 Huarahi Pai Rd Huapai",
    "Issue": "fraying and lifting round kitchen tiles",
    "Installer": "Ross",
    "CustomerName": "Cesar Romero",
    "CustomerPhone": 224140041,
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "12/08/2017",
    "Address": "78C Castledine Cres GI",
    "Issue": "refit lifting carpet",
    "Installer": "",
    "CustomerName": "Ceri John",
    "CustomerPhone": "022 391 1413",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/02/2018",
    "Address": "79 Valley Rd Puke",
    "Issue": "replace smoothedge and refit carpet",
    "Installer": "Ross",
    "CustomerName": "Carla",
    "CustomerPhone": 272822901,
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "27/09/2017",
    "Address": "21 Saltmarsh Rd Hobsonville",
    "Issue": "tuck in stairs",
    "Installer": "Ross",
    "CustomerName": "Carl",
    "CustomerPhone": 223134177,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "22/02/2018",
    "Address": "17 Fruitlands Rd Huapai",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Campbell Glennie",
    "CustomerPhone": 274724338,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "8/03/2018",
    "Address": "17 Fruitlands Rd Huapai",
    "Issue": "Replace Bar",
    "Installer": "Ross",
    "CustomerName": "Campbell Glennie",
    "CustomerPhone": 274724338,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/10/2016",
    "Address": "116 Harris Dr Millwater",
    "Issue": "Vinyl planking",
    "Installer": "Dave",
    "CustomerName": "Callum Davis",
    "CustomerPhone": "027 261 5334",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Dave",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "13/12/2017",
    "Address": "107 Hutchinson Rd Helensville",
    "Issue": "carpet lifting and clicking in underlay",
    "Installer": "Ross",
    "CustomerName": "Bryan Hodder",
    "CustomerPhone": 211434186,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 101314,
    "Received": "9/05/2016",
    "Address": "24 Walter Crescent, Millwater",
    "Issue": "Carpet is not right at top of stairs",
    "Installer": "Jared",
    "CustomerName": "Bryan & Sacha",
    "CustomerPhone": "021 076 6847",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "TBF 19/05/16",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "6/04/2017",
    "Address": "19 Lamborn Dr Papakura",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Brittany Johnson",
    "CustomerPhone": 276332526,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/03/2018",
    "Address": "9 Rangihina Rd Hobsonville",
    "Issue": "Repair holes in LG floor",
    "Installer": "Ross",
    "CustomerName": "Brendon",
    "CustomerPhone": "0217 280 18",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "4/07/2017",
    "Address": "9 Rangihina Rd Hobsonville",
    "Issue": "refit carpet lifted by toilet and on winders",
    "Installer": "",
    "CustomerName": "Brendan Holgate",
    "CustomerPhone": "021 055 0814",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "24/01/2017",
    "Address": "39 Outlook Tce Millwater",
    "Issue": "inspection Stonewood (just shading)",
    "Installer": "Ross",
    "CustomerName": "Brandt",
    "CustomerPhone": 2040092417,
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/01/2017",
    "Address": "149 Hobsonville Pt Rd",
    "Issue": "re fit carpet",
    "Installer": "Ross",
    "CustomerName": "Brandon",
    "CustomerPhone": 21750954,
    "GBContact": "Brandon Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brandon Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "21/09/2017",
    "Address": "12 Spotted Dove Rd",
    "Issue": "carpet lifting & gap at wall",
    "Installer": "Ross",
    "CustomerName": "Brandon",
    "CustomerPhone": "",
    "GBContact": "Brandon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brandon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/11/2017",
    "Address": "14 Spotted Dove Rd",
    "Issue": "carpet lifting",
    "Installer": "Ross",
    "CustomerName": "Brandon",
    "CustomerPhone": "",
    "GBContact": "Brandon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brandon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/03/2016",
    "Address": "61A Castledine Cres Glen Innes",
    "Issue": "Carpet loose on stairs",
    "Installer": "Kelvin",
    "CustomerName": "Blair",
    "CustomerPhone": "021 454 675",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "iand@universal.co.nz",
    "GBStart": "Ian Donachie",
    "Status": "Kelvin to do",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/04/2017",
    "Address": "8 Robert Might Rd Huapai",
    "Issue": "Refit carpet to new tiling",
    "Installer": "Ross",
    "CustomerName": "Bill & Linda Ensor",
    "CustomerPhone": 4125959,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "17/01/2017",
    "Address": "8 Robert Might Rd Huapai",
    "Issue": "inspection for GJ Rodney West",
    "Installer": "",
    "CustomerName": "Bill & Linda Ensor",
    "CustomerPhone": 4125959,
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sara Foley",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/03/2016",
    "Address": "128 Forestry Rd Kaukapakapa",
    "Issue": "carpet bubbled badly",
    "Installer": "Matt Bunn",
    "CustomerName": "Bev Hopper",
    "CustomerPhone": "027 271 4221",
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "",
    "Notes": "Ross &Johnny completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 665489,
    "Received": "11/05/2016",
    "Address": "25 Captain Mitchell Drive, Papakura",
    "Issue": "Tidy carpet edge near kitchen tiles",
    "Installer": "Kelvin",
    "CustomerName": "Beth",
    "CustomerPhone": "027 339 8567",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 13/05/16",
    "Notes": "Flooded the lounge and had to relay",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "7/06/2016",
    "Address": "7 Whares Court, Silverdale",
    "Issue": "Repair two carpet joins opening up",
    "Installer": "",
    "CustomerName": "Bernie",
    "CustomerPhone": "021 644 856",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "pauline.saunders@kinect.co.nz",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/04/2017",
    "Address": "5 Aro Mato Pl Huapai",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Barry McCracken",
    "CustomerPhone": 2102700588,
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/04/2017",
    "Address": "9 Woodridge Dr Stanmore Bay",
    "Issue": "Attend to joins and re nail smoothedge",
    "Installer": "Ross",
    "CustomerName": "Barry & Brenda Frost",
    "CustomerPhone": 272892327,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "9/09/2017",
    "Address": "22 Tua Tua Rd Hobsonville",
    "Issue": "refit lifting carpet on stairs",
    "Installer": "Ross",
    "CustomerName": "Barry",
    "CustomerPhone": 21927552,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 323207,
    "Received": "21/04/2016",
    "Address": "Lot 6, 28 Te Oneroa Way, Long Bay",
    "Issue": "Refit loose carpet on stair treads",
    "Installer": "Richard & Andrew",
    "CustomerName": "Audree Davey",
    "CustomerPhone": "021 158 3621",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "daveynac@outlook.co.nz",
    "GBStart": "Dean Hodgson",
    "Status": "9/05/2016",
    "Notes": "Andrew contacting customer",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/02/2016",
    "Address": "145 Hobsonville Pt Rd",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Ash&Fiona Matthews",
    "CustomerPhone": "027 274 5391",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "17/01/2017",
    "Address": "24 Kingfisher Rd Millwater",
    "Issue": "gappy on stairs",
    "Installer": "Ross",
    "CustomerName": "Anna Stephenson",
    "CustomerPhone": 211258657,
    "GBContact": "Samantha Hyland",
    "GB": "GJG OREWA EAST",
    "CustomerEmail": "",
    "GBStart": "Samantha Hyland",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/11/2017",
    "Address": "37 McNally Rd Puke",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "Anita Parbhu",
    "CustomerPhone": 21316797,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/03/2016",
    "Address": "184 Hobsonville Pt Rd",
    "Issue": "carpet lifting in places",
    "Installer": "",
    "CustomerName": "Angela Smith",
    "CustomerPhone": 2102485259,
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/02/2017",
    "Address": "27 Liquidambar Dr Hobsonville",
    "Issue": "Re stretch all stairs",
    "Installer": "Ross",
    "CustomerName": "Andy & June Ranyard",
    "CustomerPhone": "021 810 468",
    "GBContact": "Gail Blair(Universal)",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Gail Blair(Universal)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 318339,
    "Received": "16/03/2016",
    "Address": "Lot 32, 10 Arakakara Ave, Huapai",
    "Issue": "Join opened up, hole underneath carpet in middle of room, and carpet bubbling",
    "Installer": "Johnny Nicholson",
    "CustomerName": "Andrew Colgan",
    "CustomerPhone": "021 0274 5704",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "ajcolgan79@gmail.com",
    "GBStart": "Dean Hodgson",
    "Status": "11/05/2016",
    "Notes": "Customer has some reservations about nature of issues and wants to talk with installer",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "5/05/2017",
    "Address": "139 Hobsonville Pt Rd",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "Andrew",
    "CustomerPhone": "021 877 256",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/11/2017",
    "Address": "76 Squadron Dr Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Andreson Chua",
    "CustomerPhone": "",
    "GBContact": "Jason Wech",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Jason Wech",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/11/2017",
    "Address": "13 Rangihina Rd Hobsonville",
    "Issue": "restretch one stair",
    "Installer": "Ross",
    "CustomerName": "Andrea",
    "CustomerPhone": 276332433,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "17/03/2016",
    "Address": "141 Hobsonville Pt Rd",
    "Issue": "carpet lifting on stairs",
    "Installer": "",
    "CustomerName": "Andre",
    "CustomerPhone": "021 183 5276",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/10/2017",
    "Address": "217 Wainui Rd",
    "Issue": "refit carpet after fixed squeaky floor",
    "Installer": "Kelvin",
    "CustomerName": "Anand",
    "CustomerPhone": "027 8019920",
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Kelvin",
    "Notes": "Kelvin completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "28/02/2016",
    "Address": "129 Hobsonville Point Rd",
    "Issue": "restretch stairs",
    "Installer": "Ross",
    "CustomerName": "Amy Worthington",
    "CustomerPhone": "021 042 4214",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "Universal",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "30/05/2017",
    "Address": "131 Hobsonville Pt Rd",
    "Issue": "carpet lifting in several areas",
    "Installer": "",
    "CustomerName": "Amanda Alley",
    "CustomerPhone": "021 373 080",
    "GBContact": "Kara Merryweather",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Merryweather",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "11/08/2017",
    "Address": "18 Merfield St GI",
    "Issue": "knock down all pins",
    "Installer": "Ross",
    "CustomerName": "Alison",
    "CustomerPhone": 212021592,
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "31/08/2017",
    "Address": "23 Liquidambar Dr Hobsonville",
    "Issue": "replace damaged winder",
    "Installer": "Ross",
    "CustomerName": "Alex",
    "CustomerPhone": 211147841,
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/02/2018",
    "Address": "16 Glennron Lane Waiuku",
    "Issue": "carpet lifting, and trim join",
    "Installer": "Ross",
    "CustomerName": "Alex",
    "CustomerPhone": "021 067 8799",
    "GBContact": "Meridith Smit",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Smit",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "7/06/2017",
    "Address": "23 Liquidambar Dr Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "",
    "CustomerName": "Alex",
    "CustomerPhone": "021 114 7841",
    "GBContact": "Kara Smith",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Kara Smith",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 318473,
    "Received": "18/03/2016",
    "Address": "41 Liquidambar Dr, Hob Pt",
    "Issue": "Refit loose carpet on stairs, kitchen and toilet area",
    "Installer": "Richard & Andrew",
    "CustomerName": "Alex",
    "CustomerPhone": "021 0819 8520",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "lexisingleton@hotmail.com",
    "GBStart": "Dean Hodgson",
    "Status": "TBF 16/06/16",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "9/09/2016",
    "Address": "10 Belgium Road, Pukekohe",
    "Issue": "Fixed hole in carpet",
    "Installer": "Ross",
    "CustomerName": "Adrienne",
    "CustomerPhone": 21572158,
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 420237,
    "Received": "17/05/2016",
    "Address": "10 Belgium Road, Pukekohe",
    "Issue": "Carpet lifting where ensuite tiles meet bedroom",
    "Installer": "Darryll",
    "CustomerName": "Adrienne",
    "CustomerPhone": "07-8470219",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "TBF 10/06/16",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "24/05/2017",
    "Address": "18C Martindale Lane Tuakau",
    "Issue": "carpet lifting in several areas",
    "Installer": "",
    "CustomerName": "Adriana",
    "CustomerPhone": "021 179 0242",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 325995,
    "Received": "12/05/2016",
    "Address": "32 Cape Cod Drive, Gulf Har.",
    "Issue": "Carpet lifting and fraying in places",
    "Installer": "",
    "CustomerName": "Abbey",
    "CustomerPhone": "021 460 077",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "TBF 19/05/16",
    "Notes": "Down the side, back ranch slider will be open",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "16/02/2018",
    "Address": "25 Onekiritea Rd Hobsonville",
    "Issue": "Knock down pins",
    "Installer": "Ross",
    "CustomerName": "Aaron",
    "CustomerPhone": 2108379888,
    "GBContact": "Joanne Baxter",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Joanne Baxter",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/02/2018",
    "Address": "14 Papa Orchard Drive Huapai",
    "Issue": "lift carpet for new tiles to be laid and then refit",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Sarah Foley",
    "GB": "GJG HOMES WEST",
    "CustomerEmail": "",
    "GBStart": "Sarah Foley",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "14/12/2016",
    "Address": "7 Kuawa Drive Huapai",
    "Issue": "refit carpet around ranchsliders and tile areas",
    "Installer": "Dave",
    "CustomerName": "",
    "CustomerPhone": "021 128 3110",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/02/2016",
    "Address": "4 Lally Haddon Matakana",
    "Issue": "re nail and fit carpet at ranchsliders",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Ross Murray",
    "GB": "MADISON PARK HOMES LTD",
    "CustomerEmail": "",
    "GBStart": "Ross Murray",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/06/2017",
    "Address": "21 Rangihina Rd Hobsonville",
    "Issue": "relay winder lifted",
    "Installer": "",
    "CustomerName": "",
    "CustomerPhone": 21472672,
    "GBContact": "Shane Currie Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Shane Currie Uni",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "1/02/2017",
    "Address": "Lot 3 78A Castledine Cres Glen Innes",
    "Issue": "lift room to resand and fix squeaky floor",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": 212482204,
    "GBContact": "Scott",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Scott (Universal)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "29/11/2016",
    "Address": "13 Kuawa Dr Huapai",
    "Issue": "Lump under carpet in hall",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "027 886 4813 Rob Lewis",
    "GBContact": "Rob Lewis",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Rob Lewis",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/11/2017",
    "Address": "44 Tonar St",
    "Issue": "trim tufts",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021 588 591",
    "GBContact": "Rhys Baker Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Rhys Baker Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "10/02/2016",
    "Address": "Lot 27 Saltmarsh Rd Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Rhys Baker Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Rhys Baker Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/12/2016",
    "Address": "Lot 6 Onekiritea Rd Hobsonville",
    "Issue": "Cut out carpet with paint spill & re-fitted",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021588591 Rhys Baker (Universal)",
    "GBContact": "Rhys",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Rhys",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "8/06/2017",
    "Address": "22 Tua Tua Rd Hobsonville",
    "Issue": "Irish (poor job) going back to do remedials (i lifted room",
    "Installer": "Mark Irish",
    "CustomerName": "",
    "CustomerPhone": "021 556 448 (Morne)",
    "GBContact": "Morne Botha Uni",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Morne Botha Uni",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/02/2016",
    "Address": "Lot 3/25 Onekiritea Rd Hobsonville",
    "Issue": "Re stretch all stairs",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Ian Donachie",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Ian Donachie",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/11/2017",
    "Address": "37 Mapou Rd Hobsonville",
    "Issue": "carpet lifting",
    "Installer": "Grant",
    "CustomerName": "",
    "CustomerPhone": 21750257,
    "GBContact": "Dan Young Universal",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Dan Young Universal",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "2/12/2016",
    "Address": "178 Hobsonville Pt Rd",
    "Issue": "Lay smoothedge and fit carpet to tiled areas",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021977916 Damon(Universal)",
    "GBContact": "Damon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Damon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "y"
  },
  {
    "JobNumber": "",
    "Received": "2/12/2016",
    "Address": "14 Mapou Rd Hobsonville",
    "Issue": "lump under carpet",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021977916 Damon(Universal)",
    "GBContact": "Damon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Damon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "21/12/2016",
    "Address": "155 Hobsonville Point Rd",
    "Issue": "lift carpet for floor remedial& return to refit",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021 750 954 Brandon (Uni",
    "GBContact": "Brandon",
    "GB": "UNIVERSAL HOMES",
    "CustomerEmail": "",
    "GBStart": "Brandon",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "23/11/2016",
    "Address": "315 Harbourside Drive Karaka",
    "Issue": "lifting and need to staple where open at ends of joins",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Meridith Gilmour",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Meridith Gilmour",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/10/2016",
    "Address": "20 eric Farley Dr Huapai",
    "Issue": "noisy under carpet",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Steve Johnson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Steve Johnson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/10/2016",
    "Address": "18 Eric Farley Dr Huapai",
    "Issue": "Attend to join split and nap",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Steve Johnson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Steve Johnson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "19/10/2017",
    "Address": "1/66 Marua Rd Ellerslie",
    "Issue": "lump under carpet",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021 2470568",
    "GBContact": "Ryan Meynell",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Ryan Meynell",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "8/09/2016",
    "Address": "16 Captain Mitchell Dr Papakura",
    "Issue": "fraying and lifting round kitchen tiles sprouts",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Raymond",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Raymond",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "20/07/2017",
    "Address": "7 Weta Rd Hobsonville",
    "Issue": "knock down all pins",
    "Installer": "",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Mark",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Mark",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "11/05/2016",
    "Address": "16 Ruth Craig",
    "Issue": "In HWC there is a patch missing Vinyl",
    "Installer": "Dave",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Doug Stephenson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Doug Stephenson",
    "Status": "16/05/2016",
    "Notes": "",
    "Advised": "Y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "29/07/2016",
    "Address": "Lot 59, 6 malbec Pl Huapai",
    "Issue": "carpet lifting breakfast bar, and 2 glue spots to shave of",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "0273832674 Damon(tenant)",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "ross doing 3/8/16",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "10/04/2018",
    "Address": "14 Paetahi Lane",
    "Issue": "nylon thread coming out all over stairs",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "10/04/2018",
    "Address": "18 Paetahi Lane",
    "Issue": "GH Repaired holes in carpet",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dean Hodgson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dean Hodgson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": "Y"
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "20 Spotted Dove Rd",
    "Issue": "carpet lifting at tiles",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "22 Spotted Dove Rd",
    "Issue": "carpet lifting at tiles",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "24 Spotted Dove Rd",
    "Issue": "carpet lifting at tiles",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "19 Chaffinch Rd Hobsonville",
    "Issue": "carpet lifting at tiles",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "14/12/2017",
    "Address": "15 Chaffinch Rd Hobsonville",
    "Issue": "carpet lifting at tiles and hole in floor",
    "Installer": "Rommel & Robert",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "15/12/2017",
    "Address": "9 Sacred Kingfisher Dr Hobsonville",
    "Issue": "Tidy up at ranch sliders",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "Dan Jackson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Dan Jackson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "E9371",
    "Received": "27/07/2016",
    "Address": "Lot 3, 26 Aldon Lane Manurewa",
    "Issue": "Join in Lounge & hole in carpet at top of stairwell",
    "Installer": "Kelvin",
    "CustomerName": "",
    "CustomerPhone": "0275 899 364",
    "GBContact": "Christian Welham",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Christian Welham",
    "Status": "Inspection sent",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/03/2016",
    "Address": "7 Martingale Dr Kingseat",
    "Issue": "carpet lifting at transitions in hallway",
    "Installer": "Glenn W",
    "CustomerName": "",
    "CustomerPhone": 21918467,
    "GBContact": "Cam (GJ)",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Cam (GJ)",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "3/03/2016",
    "Address": "Lot 1 Merfield St Glen Innes",
    "Issue": "refit carpet at front door",
    "Installer": "",
    "CustomerName": "",
    "CustomerPhone": 21505493,
    "GBContact": "Brett McPherson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett McPherson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/10/2017",
    "Address": "11 Muirhill Plc Pokeno",
    "Issue": "lift carpet and matrix floor",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": 21505493,
    "GBContact": "Brett McPherson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett McPherson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "22/02/2016",
    "Address": "Lot 9 Merfield St Glenn Innes",
    "Issue": "re nail and fit carpet at ranchsliders",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "021 505 493",
    "GBContact": "Brett McPherson",
    "GB": "",
    "CustomerEmail": "Universal",
    "GBStart": "Brett McPherson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/08/2017",
    "Address": "12a Hurstwood Pl Glen Innes",
    "Issue": "inspect poorly laid vinyl. Craig sorting",
    "Installer": "Brian",
    "CustomerName": "",
    "CustomerPhone": "021 505 493",
    "GBContact": "Brett McPherson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett McPherson",
    "Status": "",
    "Notes": "",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "18/08/2017",
    "Address": "12b Hurstwood Pl Glen Innes",
    "Issue": "tap down pins",
    "Installer": "",
    "CustomerName": "",
    "CustomerPhone": "021 505 493",
    "GBContact": "Brett McPherson",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "Brett McPherson",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 41,
    "Received": "24/04/2018",
    "Address": "1 RAITHBURN TCE POKENO",
    "Issue": "",
    "Installer": "CARPET LIFTING",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "0278 127 980",
    "GB": "",
    "CustomerEmail": "HANNAH",
    "GBStart": "0278 127 980",
    "Status": "",
    "Notes": "MERIDITH",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 14,
    "Received": "17/04/2018",
    "Address": "LOT 150, 16 ERIC FARLEY DRIVE, HUAPAI",
    "Issue": "",
    "Installer": "LAMINATE FLOORING IS LIFTING IN KITCHEN - DAVE FIXING SATURDAY 21ST APRIL 9.00AM",
    "CustomerName": "",
    "CustomerPhone": "DAVE WALKER FIXED",
    "GBContact": "027-323 6802",
    "GB": "",
    "CustomerEmail": "PAUL",
    "GBStart": "027-323 6802",
    "Status": "",
    "Notes": "GJG WEST",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 8,
    "Received": "17/04/2018",
    "Address": "LOT 60, 23 HENLEY ROAD, KKK",
    "Issue": "",
    "Installer": "CARPET NEEDS TO BE RELAID (Grant doing 19/04/18, get his bill then charge GJ Rodney)",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "027-212 4484",
    "GB": "",
    "CustomerEmail": "GARETH",
    "GBStart": "027-212 4484",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 35,
    "Received": "19/04/2018",
    "Address": "11 RAHOPARA ST CASTOR BAY",
    "Issue": "",
    "Installer": "STAPLES IN FLOOR SHOULDNT BE ALSO ALL KNEE KICK MARKS POOR AT TRANSITIONS",
    "CustomerName": "",
    "CustomerPhone": "KELVIN TEAM",
    "GBContact": "021-773-560",
    "GB": "",
    "CustomerEmail": "DON SENIOR",
    "GBStart": "021-773-560",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 34,
    "Received": "19/04/2018",
    "Address": "CA 13, LOT 6, CHAFFINCH RD, HOB",
    "Issue": "",
    "Installer": "JOINS X 3  ROSS SIGHING / FIXING 4.00PM 19/04/2018 - ROSS TO CONFIRM",
    "CustomerName": "",
    "CustomerPhone": "WAYNE",
    "GBContact": "021-750 474",
    "GB": "",
    "CustomerEmail": "PAUL WESTWOOD",
    "GBStart": "021-750 474",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 5,
    "Received": "17/04/2018",
    "Address": "LOT 596, 11 MUIRHILL PLACE, POKENO",
    "Issue": "SOUTH",
    "Installer": "UNDERLAY LUMP UNDER CARPET -Ross fixed part. Kelvin grinding concrete 26/05/2018",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-465 848",
    "GB": "",
    "CustomerEmail": "ALLAN",
    "GBStart": "021-465 848",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 29,
    "Received": "17/04/2018",
    "Address": "36 PAMELA CHRISTINE RD, PATUMAHOE",
    "Issue": "",
    "Installer": "CARPET LIFTING",
    "CustomerName": "",
    "CustomerPhone": "ROSS INSPECTING 24/04/2018",
    "GBContact": "021-464 393",
    "GB": "",
    "CustomerEmail": "SCOTT",
    "GBStart": "021-464 393",
    "Status": "",
    "Notes": "MERIDITH",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 32,
    "Received": "17/04/2018",
    "Address": "83A, LOTS 1-9 HOBSONVILLE PT RD",
    "Issue": "",
    "Installer": "MEET AT SITE TO GO OVER CARPET",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-442 795 UNIVERSAL",
    "GB": "",
    "CustomerEmail": "JARED SIMM",
    "GBStart": "021-442 795 UNIVERSAL",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 4,
    "Received": "17/04/2018",
    "Address": "34 CAPRIANA DRIVE, KARAKA",
    "Issue": "",
    "Installer": "RE-STRETCH MOST OF HOUSE",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-396 303",
    "GB": "",
    "CustomerEmail": "BEN",
    "GBStart": "021-396 303",
    "Status": "",
    "Notes": "MERIDITH",
    "Advised": "",
    "Billed": "Ross to fix Saturday April 21 st",
    "Chargeable": ""
  },
  {
    "JobNumber": 11,
    "Received": "17/04/2018",
    "Address": "LOT 44, 10 ASTRID LANE, WELLSFORD",
    "Issue": "",
    "Installer": "PLANK NEEDS TO BE REGLUED",
    "CustomerName": "",
    "CustomerPhone": "DAVE COMPLETED 04/05/2018",
    "GBContact": "021-257 9821",
    "GB": "",
    "CustomerEmail": "JORGE",
    "GBStart": "021-257 9821",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 31,
    "Received": "17/04/2018",
    "Address": "LOT 2, 14A DIDA PARK DR, HUAPAI",
    "Issue": "",
    "Installer": "JOIN COMING APART",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-130 2582",
    "GB": "",
    "CustomerEmail": "VANESSA",
    "GBStart": "021-130 2582",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 3,
    "Received": "17/04/2018",
    "Address": "LOT 1, 127 HOBSONVILLE PT RD, HOB",
    "Issue": "",
    "Installer": "FIX CARPET AT STAIRS",
    "CustomerName": "",
    "CustomerPhone": "ANDREW WALKER",
    "GBContact": "021-0822 6071",
    "GB": "",
    "CustomerEmail": "TRACEY",
    "GBStart": "021-0822 6071",
    "Status": "",
    "Notes": "KARA SMITH",
    "Advised": "",
    "Billed": "Ross to fix Saturday April 21 st",
    "Chargeable": ""
  },
  {
    "JobNumber": 7,
    "Received": "17/04/2018",
    "Address": "LOT 20, 115 HOBSONVILLE PT RD, HOB",
    "Issue": "",
    "Installer": "SMOOTH EDGE TACKS COMING THROUGH",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-0819 9554",
    "GB": "",
    "CustomerEmail": "MATT",
    "GBStart": "021-0819 9554",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 16,
    "Received": "17/04/2018",
    "Address": "LOT 96, 14 ARO MATO PLACE, HUAPAI",
    "Issue": "",
    "Installer": "REFIX CARPET AT STAIRS",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "021-030 1793",
    "GB": "",
    "CustomerEmail": "OLIVIA",
    "GBStart": "021-030 1793",
    "Status": "",
    "Notes": "JO BAXTER",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 48,
    "Received": "24/04/2018",
    "Address": "Hull Rd Waitoki",
    "Issue": "",
    "Installer": "JOINS",
    "CustomerName": "",
    "CustomerPhone": "ROSS MADISON HOMES",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "027-270 5003",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 18,
    "Received": "17/04/2018",
    "Address": "LOT 8, 16 TONAR ST,",
    "Issue": "",
    "Installer": "JOIN - WAYNE SIGHTED AND FIXED 04/05/2018",
    "CustomerName": "",
    "CustomerPhone": "WAYNE TO CHECK",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "UNIVERSAL",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": "",
    "Received": "2/09/2017",
    "Address": "34 Bomb Pt Dr Hobsonville",
    "Issue": "remove lump under carpet in bedroom",
    "Installer": "Ross",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "Fixed by Ross",
    "Notes": "Ross completed",
    "Advised": "y",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 23,
    "Received": "17/04/2018",
    "Address": "LOT 10, 2 OLD MILL RD, MILLWATER",
    "Issue": "",
    "Installer": "VINYL LIFTING",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "CONTACT OFFICE",
    "GBStart": "",
    "Status": "",
    "Notes": "GJG RODNEY",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 36,
    "Received": "19/04/2018",
    "Address": "SHEARWATER POINT WELLS",
    "Issue": "",
    "Installer": "CARPET LIFTING AT RANCHSLIDER",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "ROSS MURRAY",
    "Advised": "",
    "Billed": "KANE FIXED",
    "Chargeable": ""
  },
  {
    "JobNumber": 37,
    "Received": "20/04/2018",
    "Address": "2 OLD MILL ROAD, STANMORE BAY",
    "Issue": "",
    "Installer": "VINYL LIFTING  GJG SHOWHOME",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "SAMANTHA HYLAND",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  },
  {
    "JobNumber": 54,
    "Received": "3/05/2018",
    "Address": "LOT 4, 38 TONAR ST",
    "Issue": "",
    "Installer": "REPAIR VINYL JOIN",
    "CustomerName": "",
    "CustomerPhone": "",
    "GBContact": "",
    "GB": "",
    "CustomerEmail": "",
    "GBStart": "",
    "Status": "",
    "Notes": "",
    "Advised": "",
    "Billed": "",
    "Chargeable": ""
  }
]

        sample.forEach((remedial)=>{
            this.remedialCommands({command:'addExistingRemedial',remedial})
        })
      }, 
      
     
      ...mapActions(['remedialCommands','setUpCompanyReferences'])
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/home/MyRemedialsTile.vue